// Generated by scripts/generate-rudder-mcp-tool-descriptors.ts. Do not edit by hand.
export const RUDDER_AGENT_CONTRACT = {
  "baselineProvenance": {
    "g0IntegrationSha": "68a5b27ce7a8c22277b6daac4838f0fe35049b3d",
    "issue": "R6Z-130",
    "previousAuthorities": [
      "cli/src/agent-v1-capabilities.ts",
      "packages/agent-runtime-utils/src/rudder-mcp-contract.ts",
      "cli/src/agent-v1-mcp-server.ts"
    ],
    "sourceAuthority": "contracts/rudder-agent-contract/v1.json"
  },
  "capabilities": [
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/agents/me",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent me",
        "contract": "agent-v1",
        "description": "Show the authenticated agent identity and budget.",
        "id": "agent.me",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.me",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Show the authenticated agent identity and budget"
        },
        "capabilityId": "agent.me",
        "description": "Show the authenticated agent identity and budget. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_agent_me"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/agents/me/inbox-lite",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent inbox",
        "contract": "agent-v1",
        "description": "List the compact assignee and reviewer work inbox for the authenticated agent.",
        "id": "agent.inbox",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.inbox",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List the compact assignee and reviewer work inbox for the authenticated agent"
        },
        "capabilityId": "agent.inbox",
        "description": "List the compact assignee and reviewer work inbox for the authenticated agent. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_agent_inbox"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/orgs/{orgId}/members/directory",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "organization",
        "command": "rudder org members --org-id <id> [--query <text>] [--type <human|agent|all>] [--limit <n>] [--cursor <cursor>]",
        "contract": "agent-v1",
        "description": "List active visible human and agent members in the authenticated organization.",
        "id": "organization.members.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "organization.members.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List active visible human and agent members in the authenticated organization"
        },
        "capabilityId": "organization.members.list",
        "description": "List active visible human and agent members in the authenticated organization. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Page size.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "query": {
              "description": "Optional member name filter.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "type": {
              "description": "Member type filter.",
              "enum": [
                "human",
                "agent",
                "all"
              ],
              "maxLength": 10,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_organization_members_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent capabilities",
        "contract": "agent-v1",
        "description": "List the stable Rudder agent command contract.",
        "id": "agent.capabilities",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.capabilities",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List the stable Rudder agent command contract"
        },
        "capabilityId": "agent.capabilities",
        "description": "List the stable Rudder agent command contract. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_agent_capabilities"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent list --org-id <id>",
        "contract": "compat",
        "description": "List agents for an organization.",
        "id": "agent.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "agent.list",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent get <agent-id-or-shortname-or-agt-ref>",
        "contract": "compat",
        "description": "Read one agent by id, shortname, or agt_<uuid-prefix> short ref.",
        "id": "agent.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.get",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "agent",
        "command": "rudder agent update [agent-id] [--title <title>] [--description <text>]",
        "contract": "agent-v1",
        "description": "Update an agent's identity fields; defaults to the authenticated agent.",
        "id": "agent.update",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.update",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Update an agent's identity fields"
        },
        "capabilityId": "agent.update",
        "description": "Update an agent's identity fields; defaults to the authenticated agent. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "capabilities": {
              "description": "Agent capability summary.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            },
            "clearCapabilities": {
              "description": "Clear the current capability summary.",
              "type": "boolean"
            },
            "clearDescription": {
              "description": "Compatibility alias for clearCapabilities.",
              "type": "boolean"
            },
            "clearTitle": {
              "description": "Clear the current title.",
              "type": "boolean"
            },
            "description": {
              "description": "Compatibility alias for capabilities.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            },
            "name": {
              "description": "Agent name.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "role": {
              "description": "Agent role.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Agent title.",
              "maxLength": 300,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_agent_update"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "agent",
        "command": "rudder agent skills create [agent-id] --name <name> [--enable]",
        "contract": "agent-v1",
        "description": "Create an agent-private skill package under AGENT_HOME/skills.",
        "id": "agent.skills.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.skills.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create an agent-private skill package under AGENT_HOME/skills"
        },
        "capabilityId": "agent.skills.create",
        "description": "Create an agent-private skill package under AGENT_HOME/skills. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "body": {
              "description": "Compatibility alias for markdown.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Skill description.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            },
            "enable": {
              "description": "Enable the created skill for the runtime agent.",
              "type": "boolean"
            },
            "markdown": {
              "description": "SKILL.md content.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "name": {
              "description": "Skill display name.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "slug": {
              "description": "Skill slug.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "name"
          ],
          "type": "object"
        },
        "name": "rudder_agent_skills_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "agent",
        "command": "rudder agent skills enable <agent-id> <selection-ref...>",
        "contract": "agent-v1",
        "description": "Add skill selections to an agent without replacing existing enabled skills.",
        "id": "agent.skills.enable",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.skills.enable",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Add skill selections to an agent without replacing existing enabled skills"
        },
        "capabilityId": "agent.skills.enable",
        "description": "Add skill selections to an agent without replacing existing enabled skills. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "selectionRefs": {
              "description": "Skill selection references.",
              "items": {
                "description": "Skill selection references.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            }
          },
          "required": [
            "selectionRefs"
          ],
          "type": "object"
        },
        "name": "rudder_agent_skills_enable"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "agent",
        "command": "rudder agent skills sync <agent-id>",
        "contract": "agent-v1",
        "description": "Sync the desired enabled skill set for an agent.",
        "id": "agent.skills.sync",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.skills.sync",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Sync the desired enabled skill set for an agent"
        },
        "capabilityId": "agent.skills.sync",
        "description": "Sync the desired enabled skill set for an agent. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "desiredSkills": {
              "description": "Comma-separated desired skill references.",
              "maxLength": 20000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "desiredSkills"
          ],
          "type": "object"
        },
        "name": "rudder_agent_skills_sync"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/orgs/{orgId}/goals/assigned",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "goal",
        "command": "rudder goal list [--lifecycle <draft|active|closed|all>] [--focus <true|false>] [--facet <facet>] [--limit <n>]",
        "contract": "agent-v1",
        "description": "Discover Goals owned by the authenticated Agent; defaults to active Goals and returns current progress, next step, and attention state.",
        "id": "goal.list",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "goal.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Discover Goals owned by the authenticated Agent"
        },
        "capabilityId": "goal.list",
        "description": "Discover Goals owned by the authenticated Agent; defaults to active Goals and returns current progress, next step, and attention state. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "facet": {
              "description": "Current Goal workspace facet.",
              "enum": [
                "agent_advancing",
                "needs_attention",
                "waiting_focus",
                "waiting_external",
                "ready_for_acceptance",
                "closed"
              ],
              "maxLength": 40,
              "minLength": 1,
              "type": "string"
            },
            "focus": {
              "description": "Filter by whether the Goal is the organization Focus Goal.",
              "type": "boolean"
            },
            "lifecycle": {
              "description": "Goal lifecycle filter; active is the safe default.",
              "enum": [
                "draft",
                "active",
                "closed",
                "all"
              ],
              "maxLength": 20,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Maximum owned Goals to return.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            }
          },
          "type": "object"
        },
        "name": "rudder_goal_list"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/goals/{goal}/agent-context",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "goal",
        "command": "rudder goal context <goal-id>",
        "contract": "agent-v1",
        "description": "Read the owned Goal agreement and current operating context before acting: contract revision, criteria, boundaries, progress, next step, attention, proposals, and recent feedback.",
        "id": "goal.context",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "goal.context",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read the owned Goal agreement and current operating context before acting: contract revision, criteria, boundaries, progress, next step, attention, proposals, and recent feedback"
        },
        "capabilityId": "goal.context",
        "description": "Read the owned Goal agreement and current operating context before acting: contract revision, criteria, boundaries, progress, next step, attention, proposals, and recent feedback. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "goal": {
              "description": "Goal UUID returned by rudder_goal_list.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "goal"
          ],
          "type": "object"
        },
        "name": "rudder_goal_context"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/goals/{goal}/activities",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "goal",
        "command": "rudder goal progress <goal-id> --summary <text> --evidence-refs <json> --idempotency-key <key>",
        "contract": "agent-v1",
        "description": "Record evidence-backed progress for a Goal owned by the authenticated Agent and attribute it to the current Run.",
        "id": "goal.progress",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": true
      },
      "id": "goal.progress",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Record evidence-backed progress for a Goal owned by the authenticated Agent and attribute it to the current Run"
        },
        "capabilityId": "goal.progress",
        "description": "Record evidence-backed progress for a Goal owned by the authenticated Agent and attribute it to the current Run. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "activityKind": {
              "description": "Progress classification.",
              "enum": [
                "progress",
                "evidence",
                "bottleneck"
              ],
              "maxLength": 30,
              "minLength": 1,
              "type": "string"
            },
            "evidenceRefs": {
              "description": "URI-like references to artifacts, measurements, or other supporting evidence.",
              "items": {
                "description": "URI-like evidence reference.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "minItems": 1,
              "type": "array"
            },
            "goal": {
              "description": "Goal UUID or typed short reference (gol_<prefix>) from the current Goal Runtime Context.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "idempotencyKey": {
              "description": "Stable key for safe retry.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "summary": {
              "description": "Plain-language progress, observed change, or named blocker.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "goal",
            "summary",
            "evidenceRefs",
            "idempotencyKey"
          ],
          "type": "object"
        },
        "name": "rudder_goal_progress"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/goals/{goal}/checkpoint",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "goal",
        "command": "rudder goal checkpoint <goal-id> --summary <text> --evidence-refs <json> --expected-plan-revision <n> --continuation <json> --idempotency-key <key>",
        "contract": "agent-v1",
        "description": "Atomically persist a Goal checkpoint, optional Plan revision, continuation, checkpoint activity, and eligible automatic continuation wake.",
        "id": "goal.checkpoint",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": true
      },
      "id": "goal.checkpoint",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Atomically persist a Goal checkpoint, optional Plan revision, continuation, checkpoint activity, and eligible automatic continuation wake"
        },
        "capabilityId": "goal.checkpoint",
        "description": "Atomically persist a Goal checkpoint, optional Plan revision, continuation, checkpoint activity, and eligible automatic continuation wake. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "continuation": {
              "additionalProperties": false,
              "properties": {
                "kind": {
                  "description": "Continuation policy.",
                  "enum": [
                    "commitment",
                    "wait",
                    "decision",
                    "verification"
                  ],
                  "maxLength": 100000,
                  "minLength": 1,
                  "type": "string"
                },
                "summary": {
                  "description": "What should happen next or what is awaited.",
                  "maxLength": 100000,
                  "minLength": 1,
                  "type": "string"
                },
                "wakeCondition": {
                  "oneOf": [
                    {
                      "minLength": 1,
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                }
              },
              "required": [
                "kind",
                "summary"
              ],
              "type": "object"
            },
            "evidenceRefs": {
              "description": "URI-like references to artifacts, measurements, or other supporting evidence.",
              "items": {
                "description": "URI-like evidence reference.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            },
            "expectedPlanRevision": {
              "description": "Plan revision read before this checkpoint.",
              "maximum": 1000000000,
              "minimum": 1,
              "type": "number"
            },
            "goal": {
              "description": "Goal UUID or typed short reference (gol_<prefix>) from the current Goal Runtime Context.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "idempotencyKey": {
              "description": "Stable key for safe retry.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "plan": {
              "additionalProperties": false,
              "description": "Optional complete next Plan revision; omit when the current Plan remains valid.",
              "properties": {
                "budgetAllocations": {
                  "additionalProperties": true,
                  "type": "object"
                },
                "hypotheses": {
                  "items": {},
                  "maxItems": 1000,
                  "type": "array"
                },
                "invalidationConditions": {
                  "items": {},
                  "maxItems": 1000,
                  "type": "array"
                },
                "rejectedPaths": {
                  "items": {},
                  "maxItems": 1000,
                  "type": "array"
                },
                "selectedPaths": {
                  "items": {},
                  "maxItems": 1000,
                  "type": "array"
                },
                "sequencing": {
                  "items": {},
                  "maxItems": 1000,
                  "type": "array"
                },
                "summary": {
                  "description": "Plan summary.",
                  "maxLength": 100000,
                  "minLength": 1,
                  "type": "string"
                }
              },
              "required": [
                "summary"
              ],
              "type": "object"
            },
            "summary": {
              "description": "Plain-language bounded-run checkpoint summary.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "goal",
            "summary",
            "evidenceRefs",
            "expectedPlanRevision",
            "continuation",
            "idempotencyKey"
          ],
          "type": "object"
        },
        "name": "rudder_goal_checkpoint"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/goals/{goal}/change-proposals",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "goal",
        "command": "rudder goal change propose <goal-id> --contract-revision <n> --after-contract <json> --rationale <text> --idempotency-key <key>",
        "contract": "agent-v1",
        "description": "Propose a reviewable change to the current Goal contract when evidence shows its outcome, criteria, boundaries, or deadlines should change.",
        "id": "goal.change.propose",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": true
      },
      "id": "goal.change.propose",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Propose a reviewable change to the current Goal contract when evidence shows its outcome, criteria, boundaries, or deadlines should change"
        },
        "capabilityId": "goal.change.propose",
        "description": "Propose a reviewable change to the current Goal contract when evidence shows its outcome, criteria, boundaries, or deadlines should change. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "afterContract": {
              "additionalProperties": false,
              "description": "Only the Goal contract fields that should change.",
              "minProperties": 1,
              "properties": {
                "actionDeadline": {
                  "description": "Proposed ISO-8601 action deadline, or null to clear it.",
                  "oneOf": [
                    {
                      "format": "date-time",
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "autonomyEnvelope": {
                  "additionalProperties": true,
                  "type": "object"
                },
                "criteria": {
                  "items": {
                    "additionalProperties": false,
                    "properties": {
                      "evaluator": {
                        "description": "Criterion evaluator.",
                        "enum": [
                          "artifact",
                          "metric",
                          "policy",
                          "human"
                        ],
                        "maxLength": 20,
                        "minLength": 1,
                        "type": "string"
                      },
                      "evidenceRequirements": {
                        "items": {
                          "description": "URI-like required evidence reference.",
                          "maxLength": 8192,
                          "minLength": 1,
                          "type": "string"
                        },
                        "maxItems": 100,
                        "type": "array"
                      },
                      "id": {
                        "description": "Stable criterion id.",
                        "maxLength": 500,
                        "minLength": 1,
                        "type": "string"
                      },
                      "label": {
                        "description": "Plain-language success criterion.",
                        "maxLength": 100000,
                        "minLength": 1,
                        "type": "string"
                      }
                    },
                    "required": [
                      "id",
                      "label",
                      "evaluator"
                    ],
                    "type": "object"
                  },
                  "maxItems": 100,
                  "minItems": 1,
                  "type": "array"
                },
                "evaluationDeadline": {
                  "description": "Proposed ISO-8601 evaluation deadline, or null to clear it.",
                  "oneOf": [
                    {
                      "format": "date-time",
                      "type": "string"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "evaluationPolicy": {
                  "additionalProperties": true,
                  "type": "object"
                },
                "humanAuthorities": {
                  "additionalProperties": true,
                  "type": "object"
                },
                "objectiveMode": {
                  "description": "Proposed objective mode.",
                  "enum": [
                    "target",
                    "maximize",
                    "maintain",
                    "decide"
                  ],
                  "maxLength": 20,
                  "minLength": 1,
                  "type": "string"
                },
                "outcomeStatement": {
                  "description": "Proposed result-oriented outcome.",
                  "maxLength": 100000,
                  "minLength": 1,
                  "type": "string"
                }
              },
              "type": "object"
            },
            "contractRevision": {
              "description": "Current Goal contract revision.",
              "maximum": 1000000000,
              "minimum": 1,
              "type": "number"
            },
            "evidenceRefs": {
              "description": "URI-like references supporting the proposed change.",
              "items": {
                "description": "URI-like evidence reference.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            },
            "goal": {
              "description": "Goal UUID or typed short reference (gol_<prefix>) from the current Goal Runtime Context.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "idempotencyKey": {
              "description": "Stable key for safe retry.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "rationale": {
              "description": "Why the current contract should change and what evidence invalidated it.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "goal",
            "contractRevision",
            "afterContract",
            "rationale",
            "idempotencyKey"
          ],
          "type": "object"
        },
        "name": "rudder_goal_change_propose"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/goals/{goal}/result-proposals",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "goal",
        "command": "rudder goal result propose <goal-id> --contract-revision <n> --criteria <json> --evidence-refs <json> --risk-summary <text> --idempotency-key <key>",
        "contract": "agent-v1",
        "description": "Submit an evidence-backed Goal result for mandatory human acceptance without closing the Goal.",
        "id": "goal.result.propose",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": true
      },
      "id": "goal.result.propose",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Submit an evidence-backed Goal result for mandatory human acceptance without closing the Goal"
        },
        "capabilityId": "goal.result.propose",
        "description": "Submit an evidence-backed Goal result for mandatory human acceptance without closing the Goal. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "contractRevision": {
              "description": "Current Goal contract revision.",
              "maximum": 1000000000,
              "minimum": 1,
              "type": "number"
            },
            "criteria": {
              "description": "Criterion outcomes for the current contract revision.",
              "items": {
                "additionalProperties": false,
                "properties": {
                  "id": {
                    "description": "Criterion id from the Goal Runtime Context.",
                    "maxLength": 500,
                    "minLength": 1,
                    "type": "string"
                  },
                  "status": {
                    "description": "Observed criterion status.",
                    "enum": [
                      "met",
                      "unmet",
                      "breached",
                      "unknown"
                    ],
                    "maxLength": 20,
                    "minLength": 1,
                    "type": "string"
                  }
                },
                "required": [
                  "id",
                  "status"
                ],
                "type": "object"
              },
              "maxItems": 100,
              "minItems": 1,
              "type": "array"
            },
            "decision": {
              "description": "Optional decision reached for decide-mode Goals.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            },
            "evidenceRefs": {
              "description": "URI-like references supporting the proposed result.",
              "items": {
                "description": "URI-like evidence reference.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "minItems": 1,
              "type": "array"
            },
            "goal": {
              "description": "Goal UUID or typed short reference (gol_<prefix>) from the current Goal Runtime Context.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "idempotencyKey": {
              "description": "Stable key for safe retry.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "resultPayload": {
              "additionalProperties": true,
              "description": "Optional structured result details.",
              "type": "object"
            },
            "resultValue": {
              "description": "Optional measured result value.",
              "oneOf": [
                {
                  "maxLength": 100000,
                  "type": "string"
                },
                {
                  "type": "number"
                },
                {
                  "type": "boolean"
                }
              ]
            },
            "riskSummary": {
              "description": "Known risks, limitations, or remaining gaps.",
              "maxLength": 100000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "goal",
            "contractRevision",
            "criteria",
            "evidenceRefs",
            "riskSummary",
            "idempotencyKey"
          ],
          "type": "object"
        },
        "name": "rudder_goal_result_propose"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "agent",
        "command": "rudder agent hire --org-id <id> --payload <json>",
        "contract": "compat",
        "description": "Create a new hire using the canonical hire workflow.",
        "id": "agent.hire",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "agent.hire",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent config index",
        "contract": "compat",
        "description": "Read the installed agent runtime configuration index.",
        "id": "agent.config.index",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.config.index",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent config doc <agent-runtime-type>",
        "contract": "compat",
        "description": "Read adapter-specific configuration guidance for one runtime.",
        "id": "agent.config.doc",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.config.doc",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent config list --org-id <id>",
        "contract": "compat",
        "description": "List redacted agent configuration snapshots for an organization.",
        "id": "agent.config.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "agent.config.list",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent config get <agent-id-or-shortname>",
        "contract": "compat",
        "description": "Read one redacted agent configuration snapshot by id or shortname.",
        "id": "agent.config.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.config.get",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "agent",
        "command": "rudder agent icons",
        "contract": "compat",
        "description": "List legacy named agent icons for compatibility/debugging; normal create and hire payloads should omit icon.",
        "id": "agent.icons",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "agent.icons",
      "mcp": null
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/issues/{issue}",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue get <issue>",
        "contract": "agent-v1",
        "description": "Read a full issue by UUID or identifier.",
        "id": "issue.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a full issue by UUID or identifier"
        },
        "capabilityId": "issue.get",
        "description": "Read a full issue by UUID or identifier. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue list --org-id <id>",
        "contract": "agent-v1",
        "description": "List issues with optional status, assignee, and project filters without requiring a search query.",
        "id": "issue.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "issue.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List issues with optional status, assignee, and project filters without requiring a search query"
        },
        "capabilityId": "issue.list",
        "description": "List issues with optional status, assignee, and project filters without requiring a search query. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Comma-separated issue statuses.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_issue_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue search <query> [--org-id <id>]",
        "contract": "agent-v1",
        "description": "Search issues with the server-side issue index across title, identifier, description, and comments.",
        "id": "issue.search",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "issue.search",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Search issues with the server-side issue index across title, identifier, description, and comments"
        },
        "capabilityId": "issue.search",
        "description": "Search issues with the server-side issue index across title, identifier, description, and comments. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "query": {
              "description": "Non-empty server-side issue search query.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Comma-separated issue statuses.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "query"
          ],
          "type": "object"
        },
        "name": "rudder_issue_search"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/issues/{issue}/heartbeat-context",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue context <issue> [--wake-comment-id <comment-id-or-cmt-ref>]",
        "contract": "agent-v1",
        "description": "Read the compact heartbeat context for an issue; wake comments may be addressed by full id or cmt_<uuid-prefix>.",
        "id": "issue.context",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.context",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read the compact heartbeat context for an issue"
        },
        "capabilityId": "issue.context",
        "description": "Read the compact heartbeat context for an issue; wake comments may be addressed by full id or cmt_<uuid-prefix>. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "wakeCommentId": {
              "description": "Wake comment id or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_context"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/issues/{issue}/checkout",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue checkout <issue>",
        "contract": "agent-v1",
        "description": "Atomically checkout an issue for the current or specified agent.",
        "id": "issue.checkout",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.checkout",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Atomically checkout an issue for the current or specified agent"
        },
        "capabilityId": "issue.checkout",
        "description": "Atomically checkout an issue for the current or specified agent. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "expectedStatuses": {
              "description": "Comma-separated allowed prior statuses.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_checkout"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/issues/{issue}/comments",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue comment <issue> --body-file <path> [--image <path>]",
        "contract": "agent-v1",
        "description": "Add a comment to an issue, optionally uploading images and appending Markdown image links.",
        "id": "issue.comment",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.comment",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Add a comment to an issue, optionally uploading images and appending Markdown image links"
        },
        "capabilityId": "issue.comment",
        "description": "Add a comment to an issue, optionally uploading images and appending Markdown image links. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "body"
              ]
            },
            {
              "required": [
                "comment"
              ]
            }
          ],
          "properties": {
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "images": {
              "description": "Local image paths to attach.",
              "items": {
                "description": "Local image paths to attach.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "reopen": {
              "description": "Reopen the issue while commenting.",
              "type": "boolean"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_comment"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/issues/{issue}/comments",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue comments list <issue> [--after <comment-id-or-cmt-ref>]",
        "contract": "agent-v1",
        "description": "List issue comments, optionally only newer comments after a full comment id or cmt_<uuid-prefix> with --after.",
        "id": "issue.comments.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.comments.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List issue comments, optionally only newer comments after a full comment id or cmt_<uuid-prefix> with --after"
        },
        "capabilityId": "issue.comments.list",
        "description": "List issue comments, optionally only newer comments after a full comment id or cmt_<uuid-prefix> with --after. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "after": {
              "description": "Return comments after this comment id or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "order": {
              "description": "Comment order.",
              "enum": [
                "asc",
                "desc"
              ],
              "maxLength": 10,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_comments_list"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/issues/{issue}/comments/{comment}",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue comments get <issue> <comment-id-or-cmt-ref>",
        "contract": "agent-v1",
        "description": "Read one issue comment by full id or cmt_<uuid-prefix> scoped to the issue.",
        "id": "issue.comments.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.comments.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one issue comment by full id or cmt_<uuid-prefix> scoped to the issue"
        },
        "capabilityId": "issue.comments.get",
        "description": "Read one issue comment by full id or cmt_<uuid-prefix> scoped to the issue. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "comment": {
              "description": "Comment id or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue",
            "comment"
          ],
          "type": "object"
        },
        "name": "rudder_issue_comments_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue update <issue> ... [--comment-file <path>] [--image <path>]",
        "contract": "agent-v1",
        "description": "Apply generic issue updates when workflow commands are not enough, optionally uploading images for the update comment.",
        "id": "issue.update",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.update",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Apply generic issue updates when workflow commands are not enough, optionally uploading images for the update comment"
        },
        "capabilityId": "issue.update",
        "description": "Apply generic issue updates when workflow commands are not enough, optionally uploading images for the update comment. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "billingCode": {
              "description": "Billing code.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Issue description.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "hiddenAt": {
              "description": "Hidden timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "images": {
              "description": "Local image paths to attach.",
              "items": {
                "description": "Local image paths to attach.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "parentId": {
              "description": "Parent issue id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "priority": {
              "description": "New issue priority.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "requestDepth": {
              "description": "Requested issue depth.",
              "maxLength": 30,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "New issue status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Issue title.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_update"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue review <issue> --decision <decision> --comment-file <path>",
        "contract": "agent-v1",
        "description": "Record a structured reviewer decision with a required comment.",
        "id": "issue.review",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.review",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Record a structured reviewer decision with a required comment"
        },
        "capabilityId": "issue.review",
        "description": "Record a structured reviewer decision with a required comment. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "comment"
              ]
            },
            {
              "required": [
                "body"
              ]
            }
          ],
          "properties": {
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "decision": {
              "description": "Structured review decision.",
              "enum": [
                "approve",
                "request_changes",
                "needs_followup",
                "blocked"
              ],
              "maxLength": 30,
              "minLength": 1,
              "type": "string"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue",
            "decision"
          ],
          "type": "object"
        },
        "name": "rudder_issue_review"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue commit <issue> --sha <sha> --message <subject>",
        "contract": "agent-v1",
        "description": "Report a code commit created during issue work as structured issue activity.",
        "id": "issue.commit",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.commit",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Report a code commit created during issue work as structured issue activity"
        },
        "capabilityId": "issue.commit",
        "description": "Report a code commit created during issue work as structured issue activity. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "branch": {
              "description": "Git branch name.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "count": {
              "description": "Number of commits represented.",
              "maximum": 10000,
              "minimum": 1,
              "type": "number"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "message": {
              "description": "Commit subject or status message.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "repoPath": {
              "description": "Repository path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            },
            "sha": {
              "description": "Git commit SHA.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "workspacePath": {
              "description": "Workspace path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue",
            "sha",
            "message"
          ],
          "type": "object"
        },
        "name": "rudder_issue_commit"
      }
    },
    {
      "api": {
        "method": "PATCH",
        "pathTemplate": "/api/issues/{issue}",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue done <issue> --comment-file <path> [--image <path>]",
        "contract": "agent-v1",
        "description": "Mark an issue done with a required completion comment, optionally uploading images.",
        "id": "issue.done",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.done",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Mark an issue done with a required completion comment, optionally uploading images"
        },
        "capabilityId": "issue.done",
        "description": "Mark an issue done with a required completion comment, optionally uploading images. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "comment"
              ]
            },
            {
              "required": [
                "body"
              ]
            }
          ],
          "properties": {
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "images": {
              "description": "Local image paths to attach.",
              "items": {
                "description": "Local image paths to attach.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_done"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue block <issue> --comment-file <path> [--image <path>]",
        "contract": "agent-v1",
        "description": "Request human assistance after bounded recovery attempts; repeated matching claims are audited before the Issue becomes blocked.",
        "id": "issue.block",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "issue.block",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Request human assistance after bounded recovery attempts"
        },
        "capabilityId": "issue.block",
        "description": "Request human assistance after bounded recovery attempts; repeated matching claims are audited before the Issue becomes blocked. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "comment"
              ]
            },
            {
              "required": [
                "body"
              ]
            }
          ],
          "properties": {
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "images": {
              "description": "Local image paths to attach.",
              "items": {
                "description": "Local image paths to attach.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 20,
              "type": "array"
            },
            "issue": {
              "description": "Issue UUID, identifier, or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "issue"
          ],
          "type": "object"
        },
        "name": "rudder_issue_block"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "project",
        "command": "rudder project list --org-id <id>",
        "contract": "agent-v1",
        "description": "List projects in an organization.",
        "id": "project.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "project.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List projects in an organization"
        },
        "capabilityId": "project.list",
        "description": "List projects in an organization. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_project_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "project",
        "command": "rudder project get <project-id-or-shortname> [--org-id <id>]",
        "contract": "agent-v1",
        "description": "Read one project by ID or shortname.",
        "id": "project.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "project.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one project by ID or shortname"
        },
        "capabilityId": "project.get",
        "description": "Read one project by ID or shortname. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "project": {
              "description": "Project UUID or shortname.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "project"
          ],
          "type": "object"
        },
        "name": "rudder_project_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "project",
        "command": "rudder project create --org-id <id> --name <name>",
        "contract": "agent-v1",
        "description": "Create a project in the organization.",
        "id": "project.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "project.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create a project in the organization"
        },
        "capabilityId": "project.create",
        "description": "Create a project in the organization. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "color": {
              "description": "Display color.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Project description.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "goalIds": {
              "description": "Goal ids.",
              "items": {
                "description": "Goal ids.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            },
            "leadAgentId": {
              "description": "Lead agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "name": {
              "description": "Project name.",
              "maxLength": 300,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Project status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "targetDate": {
              "description": "Target date.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "name"
          ],
          "type": "object"
        },
        "name": "rudder_project_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "project",
        "command": "rudder project update <project-id-or-shortname> [--org-id <id>]",
        "contract": "agent-v1",
        "description": "Update mutable project fields such as name, description, status, goals, lead agent, target date, color, or archivedAt.",
        "id": "project.update",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "project.update",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Update mutable project fields such as name, description, status, goals, lead agent, target date, color, or archivedAt"
        },
        "capabilityId": "project.update",
        "description": "Update mutable project fields such as name, description, status, goals, lead agent, target date, color, or archivedAt. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "archivedAt": {
              "description": "Archive timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "color": {
              "description": "Display color.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Project description.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "goalIds": {
              "description": "Goal ids.",
              "items": {
                "description": "Goal ids.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            },
            "leadAgentId": {
              "description": "Lead agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "name": {
              "description": "Project name.",
              "maxLength": 300,
              "minLength": 1,
              "type": "string"
            },
            "project": {
              "description": "Project UUID or shortname.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Project status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "targetDate": {
              "description": "Target date.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "project"
          ],
          "type": "object"
        },
        "name": "rudder_project_update"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "user",
        "command": "rudder user activity --user me --since today --json",
        "contract": "agent-v1",
        "description": "Read a user-centered activity ledger with safe excerpts and provenance across chats, issue comments, approval comments, and user actor activity.",
        "id": "user.activity",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "user.activity",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a user-centered activity ledger with safe excerpts and provenance across chats, issue comments, approval comments, and user actor activity"
        },
        "capabilityId": "user.activity",
        "description": "Read a user-centered activity ledger with safe excerpts and provenance across chats, issue comments, approval comments, and user actor activity. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "include": {
              "description": "Comma-separated optional sections.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "issueId": {
              "description": "Issue id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Page size.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "projectId": {
              "description": "Project id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "relatedAgentId": {
              "description": "Related agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "since": {
              "description": "Activity start timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "until": {
              "description": "Activity end timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "user": {
              "description": "User id, reference, or self.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_user_activity"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "library",
        "command": "rudder library file list [directory]",
        "contract": "agent-v1",
        "description": "List Library files and folders; file rows include `libraryEntryId` when a strong reference can be generated.",
        "id": "library.file.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "library.file.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List Library files and folders"
        },
        "capabilityId": "library.file.list",
        "description": "List Library files and folders; file rows include `libraryEntryId` when a strong reference can be generated. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "directory": {
              "description": "Library-relative directory path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            },
            "path": {
              "description": "Compatibility alias for directory.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_library_file_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "library",
        "command": "rudder library file get <path>",
        "contract": "agent-v1",
        "description": "Fallback read when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`.",
        "id": "library.file.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "library.file.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Fallback read when local filesystem access is unavailable"
        },
        "capabilityId": "library.file.get",
        "description": "Fallback read when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "path": {
              "description": "Library-relative file path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "path"
          ],
          "type": "object"
        },
        "name": "rudder_library_file_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "library",
        "command": "rudder library file ref <path>",
        "contract": "agent-v1",
        "description": "Return the stable Markdown reference for one Library file without printing file content.",
        "id": "library.file.ref",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "library.file.ref",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Return the stable Markdown reference for one Library file without printing file content"
        },
        "capabilityId": "library.file.ref",
        "description": "Return the stable Markdown reference for one Library file without printing file content. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "path": {
              "description": "Library-relative file path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "path"
          ],
          "type": "object"
        },
        "name": "rudder_library_file_ref"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "library",
        "command": "rudder library file link <path>",
        "contract": "agent-v1",
        "description": "Compatibility alias for `rudder library file ref <path>`.",
        "id": "library.file.link",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "library.file.link",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Compatibility alias for `rudder library file ref <path>`"
        },
        "capabilityId": "library.file.link",
        "description": "Compatibility alias for `rudder library file ref <path>`. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "path": {
              "description": "Library-relative file path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "path"
          ],
          "type": "object"
        },
        "name": "rudder_library_file_link"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "library",
        "command": "rudder library file put <path> --body-file <path>",
        "contract": "agent-v1",
        "description": "Fallback create/update when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`.",
        "id": "library.file.put",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "library.file.put",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Fallback create/update when local filesystem access is unavailable"
        },
        "capabilityId": "library.file.put",
        "description": "Fallback create/update when local filesystem access is unavailable; JSON includes `mentionHref` and `markdownLink`. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "body"
              ]
            },
            {
              "required": [
                "content"
              ]
            }
          ],
          "properties": {
            "body": {
              "description": "Direct file content.",
              "maxLength": 1000000,
              "minLength": 1,
              "type": "string"
            },
            "content": {
              "description": "Compatibility alias for body.",
              "maxLength": 1000000,
              "minLength": 1,
              "type": "string"
            },
            "path": {
              "description": "Library-relative file path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "path"
          ],
          "type": "object"
        },
        "name": "rudder_library_file_put"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/orgs/{orgId}/issues",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "issue",
        "command": "rudder issue create --org-id <id> ... [--label-id <id> ...] [--label <name> ...]",
        "contract": "agent-v1",
        "description": "Create a new issue or subtask with the generic issue surface; agent-created issues default to the creating agent when no assignee is supplied.",
        "id": "issue.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "issue.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create a new issue or subtask with the generic issue surface"
        },
        "capabilityId": "issue.create",
        "description": "Create a new issue or subtask with the generic issue surface; agent-created issues default to the creating agent when no assignee is supplied. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "billingCode": {
              "description": "Billing code.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Issue description.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "labelIds": {
              "description": "Issue label ids.",
              "items": {
                "description": "Issue label ids.",
                "maxLength": 8192,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 100,
              "type": "array"
            },
            "parentId": {
              "description": "Parent issue id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "priority": {
              "description": "Issue priority.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id or reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "requestDepth": {
              "description": "Requested issue depth.",
              "maximum": 10000,
              "minimum": 0,
              "type": "number"
            },
            "status": {
              "description": "Issue status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Issue title.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "title"
          ],
          "type": "object"
        },
        "name": "rudder_issue_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "issue",
        "command": "rudder issue labels list --org-id <id>",
        "contract": "compat",
        "description": "List organization issue labels available for issue creation.",
        "id": "issue.labels.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "issue.labels.list",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "approval",
        "command": "rudder approval get <approval-id>",
        "contract": "agent-v1",
        "description": "Read one approval request.",
        "id": "approval.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "approval.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one approval request"
        },
        "capabilityId": "approval.get",
        "description": "Read one approval request. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "approval": {
              "description": "Approval UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "approval"
          ],
          "type": "object"
        },
        "name": "rudder_approval_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "approval",
        "command": "rudder approval create --org-id <id> --type <type> --payload <json>",
        "contract": "compat",
        "description": "Create a new approval request.",
        "id": "approval.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "approval.create",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "approval",
        "command": "rudder approval issues <approval-id>",
        "contract": "agent-v1",
        "description": "List the issues linked to an approval.",
        "id": "approval.issues",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "approval.issues",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List the issues linked to an approval"
        },
        "capabilityId": "approval.issues",
        "description": "List the issues linked to an approval. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "approval": {
              "description": "Approval UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "approval"
          ],
          "type": "object"
        },
        "name": "rudder_approval_issues"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "approval",
        "command": "rudder approval comment <approval-id> --body-file <path>",
        "contract": "agent-v1",
        "description": "Add a comment to an approval.",
        "id": "approval.comment",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "approval.comment",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Add a comment to an approval"
        },
        "capabilityId": "approval.comment",
        "description": "Add a comment to an approval. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "anyOf": [
            {
              "required": [
                "body"
              ]
            },
            {
              "required": [
                "comment"
              ]
            }
          ],
          "properties": {
            "approval": {
              "description": "Approval UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "body": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "comment": {
              "description": "Direct Markdown body.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "approval"
          ],
          "type": "object"
        },
        "name": "rudder_approval_comment"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "approval",
        "command": "rudder approval resubmit <approval-id> [--payload <json>]",
        "contract": "compat",
        "description": "Resubmit a revision-requested approval, optionally with updated payload.",
        "id": "approval.resubmit",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "approval.resubmit",
      "mcp": null
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "skill",
        "command": "rudder skill list --org-id <id>",
        "contract": "agent-v1",
        "description": "List organization-visible skills.",
        "id": "skill.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List organization-visible skills"
        },
        "capabilityId": "skill.list",
        "description": "List organization-visible skills. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_skill_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "skill",
        "command": "rudder skill search <query> --org-id <id>",
        "contract": "agent-v1",
        "description": "Search organization-visible skills by name, slug, description, or source.",
        "id": "skill.search",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.search",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Search organization-visible skills by name, slug, description, or source"
        },
        "capabilityId": "skill.search",
        "description": "Search organization-visible skills by name, slug, description, or source. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "query": {
              "description": "Skill name, slug, description, source, or selection key to search for.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "query"
          ],
          "type": "object"
        },
        "name": "rudder_skill_search"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "skill",
        "command": "rudder skill get <skill-id> --org-id <id>",
        "contract": "agent-v1",
        "description": "Read one organization skill detail.",
        "id": "skill.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one organization skill detail"
        },
        "capabilityId": "skill.get",
        "description": "Read one organization skill detail. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "skill": {
              "description": "Organization skill id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "skill"
          ],
          "type": "object"
        },
        "name": "rudder_skill_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "skill",
        "command": "rudder skill file <skill-id> --org-id <id> [--path SKILL.md]",
        "contract": "agent-v1",
        "description": "Read one file from an organization skill package.",
        "id": "skill.file",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.file",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one file from an organization skill package"
        },
        "capabilityId": "skill.file",
        "description": "Read one file from an organization skill package. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "path": {
              "description": "Skill package file path.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            },
            "skill": {
              "description": "Organization skill id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "skill"
          ],
          "type": "object"
        },
        "name": "rudder_skill_file"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "skill",
        "command": "rudder skill import --org-id <id> --source <source>",
        "contract": "agent-v1",
        "description": "Import a skill package into the organization skill library.",
        "id": "skill.import",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.import",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Import a skill package into the organization skill library"
        },
        "capabilityId": "skill.import",
        "description": "Import a skill package into the organization skill library. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "source": {
              "description": "Local path, URL, or repository reference.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "source"
          ],
          "type": "object"
        },
        "name": "rudder_skill_import"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "skill",
        "command": "rudder skill scan-local --org-id <id> [--roots <csv>]",
        "contract": "agent-v1",
        "description": "Scan local roots for skill packages and import new ones.",
        "id": "skill.scan-local",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.scan-local",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Scan local roots for skill packages and import new ones"
        },
        "capabilityId": "skill.scan-local",
        "description": "Scan local roots for skill packages and import new ones. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "roots": {
              "description": "Comma-separated local roots.",
              "maxLength": 20000,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_skill_scan_local"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "skill",
        "command": "rudder skill scan-projects --org-id <id> [--project-ids <csv>] [--workspace-ids <csv>]",
        "contract": "agent-v1",
        "description": "Scan the org workspace and any legacy project workspace records for skill packages and import new ones.",
        "id": "skill.scan-projects",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "skill.scan-projects",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Scan the org workspace and any legacy project workspace records for skill packages and import new ones"
        },
        "capabilityId": "skill.scan-projects",
        "description": "Scan the org workspace and any legacy project workspace records for skill packages and import new ones. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "projectIds": {
              "description": "Comma-separated project ids.",
              "maxLength": 20000,
              "minLength": 1,
              "type": "string"
            },
            "workspaceIds": {
              "description": "Comma-separated workspace ids.",
              "maxLength": 20000,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_skill_scan_projects"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "plugin",
        "command": "rudder plugin search <query> --org-id <id>",
        "contract": "agent-v1",
        "description": "Search installed, local, and discoverable Rudder plugins.",
        "id": "plugin.search",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "plugin.search",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Search installed, local, and discoverable Rudder plugins"
        },
        "capabilityId": "plugin.search",
        "description": "Search installed, local, and discoverable Rudder plugins. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "query": {
              "description": "Plugin name, description, publisher, source, or component to search for.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "query"
          ],
          "type": "object"
        },
        "name": "rudder_plugin_search"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "plugin",
        "command": "rudder plugin get <plugin-id> --org-id <id>",
        "contract": "agent-v1",
        "description": "Read an installed plugin, including its components and current setup state; use this to resolve plugin:// references.",
        "id": "plugin.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "plugin.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read an installed plugin, including its components and current setup state"
        },
        "capabilityId": "plugin.get",
        "description": "Read an installed plugin, including its components and current setup state; use this to resolve plugin:// references. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "plugin": {
              "description": "Installed plugin UUID from a plugin:// reference or plugin search result.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "plugin"
          ],
          "type": "object"
        },
        "name": "rudder_plugin_get"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/tabs",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "browser",
        "command": "rudder browser tabs",
        "contract": "agent-v1",
        "description": "List Browser tabs owned by the current Rudder agent run.",
        "id": "browser.tabs",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.tabs",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List Browser tabs owned by the current Rudder agent run"
        },
        "capabilityId": "browser.tabs",
        "description": "List Browser tabs owned by the current Rudder agent run. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_browser_tabs"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/user_tabs",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "browser",
        "command": "rudder browser user-tabs",
        "contract": "agent-v1",
        "description": "List user-visible tabs currently open in Rudder's built-in Browser without taking control of them.",
        "id": "browser.user-tabs",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.user-tabs",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List user-visible tabs currently open in Rudder's built-in Browser without taking control of them"
        },
        "capabilityId": "browser.user-tabs",
        "description": "List user-visible tabs currently open in Rudder's built-in Browser without taking control of them. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {},
          "type": "object"
        },
        "name": "rudder_browser_user_tabs"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/open",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser open <url>",
        "contract": "agent-v1",
        "description": "Open a run-owned tab in the Rudder Browser.",
        "id": "browser.open",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.open",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "openWorldHint": true,
          "readOnlyHint": false,
          "title": "Open a run-owned tab in the Rudder Browser"
        },
        "capabilityId": "browser.open",
        "description": "Open a run-owned tab in the Rudder Browser. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "url": {
              "description": "HTTP or HTTPS URL.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "url"
          ],
          "type": "object"
        },
        "name": "rudder_browser_open"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/navigate",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser navigate <tab-id> <url>",
        "contract": "agent-v1",
        "description": "Navigate a run-owned Rudder Browser tab.",
        "id": "browser.navigate",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.navigate",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "openWorldHint": true,
          "readOnlyHint": false,
          "title": "Navigate a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.navigate",
        "description": "Navigate a run-owned Rudder Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            },
            "url": {
              "description": "HTTP or HTTPS URL.",
              "maxLength": 8192,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "url"
          ],
          "type": "object"
        },
        "name": "rudder_browser_navigate"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/back",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser back <tab-id>",
        "contract": "agent-v1",
        "description": "Navigate a run-owned Rudder Browser tab back in history.",
        "id": "browser.back",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.back",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Navigate a run-owned Rudder Browser tab back in history"
        },
        "capabilityId": "browser.back",
        "description": "Navigate a run-owned Rudder Browser tab back in history. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_back"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/forward",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser forward <tab-id>",
        "contract": "agent-v1",
        "description": "Navigate a run-owned Rudder Browser tab forward in history.",
        "id": "browser.forward",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.forward",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Navigate a run-owned Rudder Browser tab forward in history"
        },
        "capabilityId": "browser.forward",
        "description": "Navigate a run-owned Rudder Browser tab forward in history. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_forward"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/reload",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser reload <tab-id>",
        "contract": "agent-v1",
        "description": "Reload a run-owned Rudder Browser tab.",
        "id": "browser.reload",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.reload",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": false,
          "title": "Reload a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.reload",
        "description": "Reload a run-owned Rudder Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_reload"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/viewport",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser viewport --action <get|set|reset> [--width <px> --height <px>]",
        "contract": "agent-v1",
        "description": "Inspect, set, or reset the responsive viewport for the current Rudder Browser run.",
        "id": "browser.viewport",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.viewport",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Inspect, set, or reset the responsive viewport for the current Rudder Browser run"
        },
        "capabilityId": "browser.viewport",
        "description": "Inspect, set, or reset the responsive viewport for the current Rudder Browser run. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Viewport action.",
              "enum": [
                "get",
                "set",
                "reset"
              ],
              "type": "string"
            },
            "height": {
              "description": "Viewport height in CSS pixels.",
              "maximum": 2160,
              "minimum": 240,
              "type": "number"
            },
            "width": {
              "description": "Viewport width in CSS pixels.",
              "maximum": 3840,
              "minimum": 320,
              "type": "number"
            }
          },
          "required": [
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_viewport"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/visibility",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser visibility [--visible <true|false>]",
        "contract": "agent-v1",
        "description": "Inspect or change whether the current run's selected Rudder Browser tab is visible.",
        "id": "browser.visibility",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.visibility",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Inspect or change whether the current run's selected Rudder Browser tab is visible"
        },
        "capabilityId": "browser.visibility",
        "description": "Inspect or change whether the current run's selected Rudder Browser tab is visible. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "visible": {
              "description": "Whether the selected Agent Browser tab is visible.",
              "type": "boolean"
            }
          },
          "type": "object"
        },
        "name": "rudder_browser_visibility"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/snapshot",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser snapshot <tab-id> [--input <json>]",
        "contract": "agent-v1",
        "description": "Capture a bounded DOM and accessibility-oriented snapshot, including frame structure and ephemeral node ids.",
        "id": "browser.snapshot",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.snapshot",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Capture a bounded DOM and accessibility-oriented snapshot, including frame structure and ephemeral node ids"
        },
        "capabilityId": "browser.snapshot",
        "description": "Capture a bounded DOM and accessibility-oriented snapshot, including frame structure and ephemeral node ids. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "boxes": {
              "description": "Include viewport-relative element boxes.",
              "type": "boolean"
            },
            "depth": {
              "description": "Maximum snapshot tree depth.",
              "maximum": 30,
              "minimum": 1,
              "type": "number"
            },
            "maxNodes": {
              "description": "Maximum snapshot nodes.",
              "maximum": 3000,
              "minimum": 1,
              "type": "number"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_snapshot"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/locator",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser locator <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Perform read-only bounded Browser locator text, attribute, state, count, or wait operations.",
        "id": "browser.locator",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.locator",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Perform read-only bounded Browser locator text, attribute, state, count, or wait operations"
        },
        "capabilityId": "browser.locator",
        "description": "Perform read-only bounded Browser locator text, attribute, state, count, or wait operations. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Read-only locator action.",
              "enum": [
                "count",
                "allTextContents",
                "textContent",
                "innerText",
                "attribute",
                "visible",
                "enabled",
                "checked",
                "selected",
                "wait"
              ],
              "type": "string"
            },
            "locator": {
              "additionalProperties": false,
              "properties": {
                "and": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "exact": {
                  "description": "Require an exact text or attribute match.",
                  "type": "boolean"
                },
                "filter": {
                  "additionalProperties": false,
                  "properties": {
                    "has": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNot": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNotText": {
                      "description": "Excluded descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "hasText": {
                      "description": "Required descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "visible": {
                      "description": "Filter by current visibility.",
                      "type": "boolean"
                    }
                  },
                  "type": "object"
                },
                "frame": {
                  "items": {
                    "description": "CSS iframe selector.",
                    "maxLength": 1000,
                    "minLength": 1,
                    "type": "string"
                  },
                  "maxItems": 8,
                  "type": "array"
                },
                "index": {
                  "description": "Zero-based locator match index.",
                  "maximum": 499,
                  "minimum": 0,
                  "type": "number"
                },
                "name": {
                  "description": "Accessible name used with the role strategy.",
                  "maxLength": 2000,
                  "type": "string"
                },
                "or": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "position": {
                  "description": "Locator endpoint after an explicit count.",
                  "enum": [
                    "first",
                    "last"
                  ],
                  "type": "string"
                },
                "scope": {
                  "additionalProperties": false,
                  "properties": {
                    "and": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "filter": {
                      "additionalProperties": false,
                      "properties": {
                        "has": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNot": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNotText": {
                          "description": "Excluded descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "hasText": {
                          "description": "Required descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "visible": {
                          "description": "Filter by current visibility.",
                          "type": "boolean"
                        }
                      },
                      "type": "object"
                    },
                    "index": {
                      "description": "Zero-based locator match index.",
                      "maximum": 499,
                      "minimum": 0,
                      "type": "number"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "or": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "position": {
                      "description": "Locator endpoint after an explicit count.",
                      "enum": [
                        "first",
                        "last"
                      ],
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "strategy": {
                  "description": "Locator strategy.",
                  "enum": [
                    "css",
                    "testId",
                    "href",
                    "role",
                    "label",
                    "placeholder",
                    "text"
                  ],
                  "type": "string"
                },
                "value": {
                  "description": "Selector, role, label, placeholder, href, test id, or text value.",
                  "maxLength": 2000,
                  "minLength": 1,
                  "type": "string"
                }
              },
              "required": [
                "strategy",
                "value"
              ],
              "type": "object"
            },
            "name": {
              "description": "Attribute name for attribute reads.",
              "maxLength": 200,
              "type": "string"
            },
            "state": {
              "description": "Wait state.",
              "enum": [
                "attached",
                "detached",
                "visible",
                "hidden"
              ],
              "type": "string"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            },
            "timeoutMs": {
              "description": "Wait timeout in milliseconds.",
              "maximum": 30000,
              "minimum": 0,
              "type": "number"
            }
          },
          "required": [
            "tabId",
            "action",
            "locator"
          ],
          "type": "object"
        },
        "name": "rudder_browser_locator"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/cua",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser cua <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Perform trusted coordinate mouse, scroll, drag, keyboard, and text input in a run-owned Browser tab.",
        "id": "browser.cua",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.cua",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Perform trusted coordinate mouse, scroll, drag, keyboard, and text input in a run-owned Browser tab"
        },
        "capabilityId": "browser.cua",
        "description": "Perform trusted coordinate mouse, scroll, drag, keyboard, and text input in a run-owned Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Coordinate input or inspection action.",
              "enum": [
                "click",
                "doubleClick",
                "move",
                "scroll",
                "drag",
                "keypress",
                "type",
                "elementInfo"
              ],
              "type": "string"
            },
            "button": {
              "oneOf": [
                {
                  "description": "Mouse button number.",
                  "maximum": 5,
                  "minimum": 1,
                  "type": "number"
                },
                {
                  "description": "Mouse button.",
                  "enum": [
                    "left",
                    "middle",
                    "right"
                  ],
                  "type": "string"
                }
              ]
            },
            "keys": {
              "items": {
                "description": "Keyboard key or modifier.",
                "maxLength": 100,
                "minLength": 1,
                "type": "string"
              },
              "maxItems": 10,
              "type": "array"
            },
            "path": {
              "items": {
                "additionalProperties": false,
                "properties": {
                  "x": {
                    "description": "Path X coordinate.",
                    "type": "number"
                  },
                  "y": {
                    "description": "Path Y coordinate.",
                    "type": "number"
                  }
                },
                "required": [
                  "x",
                  "y"
                ],
                "type": "object"
              },
              "maxItems": 200,
              "minItems": 2,
              "type": "array"
            },
            "scrollX": {
              "description": "Horizontal scroll delta.",
              "type": "number"
            },
            "scrollY": {
              "description": "Vertical scroll delta.",
              "type": "number"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            },
            "text": {
              "description": "Text to type.",
              "maxLength": 100000,
              "type": "string"
            },
            "x": {
              "description": "Viewport X coordinate.",
              "type": "number"
            },
            "y": {
              "description": "Viewport Y coordinate.",
              "type": "number"
            }
          },
          "required": [
            "tabId",
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_cua"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/dom_cua",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser dom-cua <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Inspect a bounded read-only DOM snapshot with ephemeral node ids.",
        "id": "browser.dom-cua",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.dom-cua",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Inspect a bounded read-only DOM snapshot with ephemeral node ids"
        },
        "capabilityId": "browser.dom-cua",
        "description": "Inspect a bounded read-only DOM snapshot with ephemeral node ids. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Read-only DOM snapshot action.",
              "enum": [
                "get"
              ],
              "type": "string"
            },
            "depth": {
              "description": "Maximum DOM depth.",
              "maximum": 30,
              "minimum": 1,
              "type": "number"
            },
            "maxNodes": {
              "description": "Maximum DOM nodes.",
              "maximum": 3000,
              "minimum": 1,
              "type": "number"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_dom_cua"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/dialog",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser dialog <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Inspect, accept, or dismiss the active JavaScript dialog in a run-owned Browser tab.",
        "id": "browser.dialog",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.dialog",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Inspect, accept, or dismiss the active JavaScript dialog in a run-owned Browser tab"
        },
        "capabilityId": "browser.dialog",
        "description": "Inspect, accept, or dismiss the active JavaScript dialog in a run-owned Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Dialog action.",
              "enum": [
                "get",
                "accept",
                "dismiss"
              ],
              "type": "string"
            },
            "promptText": {
              "description": "Prompt response text.",
              "maxLength": 10000,
              "type": "string"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_dialog"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/clipboard",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser clipboard --input <json>",
        "contract": "agent-v1",
        "description": "Read or write the isolated virtual clipboard for the current Browser run without touching the OS clipboard.",
        "id": "browser.clipboard",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.clipboard",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Read or write the isolated virtual clipboard for the current Browser run without touching the OS clipboard"
        },
        "capabilityId": "browser.clipboard",
        "description": "Read or write the isolated virtual clipboard for the current Browser run without touching the OS clipboard. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Virtual clipboard action.",
              "enum": [
                "read",
                "readText",
                "write",
                "writeText",
                "clear"
              ],
              "type": "string"
            },
            "items": {
              "items": {
                "additionalProperties": false,
                "properties": {
                  "entries": {
                    "items": {
                      "additionalProperties": false,
                      "properties": {
                        "base64": {
                          "description": "Base64 clipboard payload.",
                          "maxLength": 650000,
                          "type": "string"
                        },
                        "mimeType": {
                          "description": "Clipboard MIME type.",
                          "maxLength": 200,
                          "minLength": 1,
                          "type": "string"
                        },
                        "text": {
                          "description": "Text clipboard payload.",
                          "maxLength": 500000,
                          "type": "string"
                        }
                      },
                      "required": [
                        "mimeType"
                      ],
                      "type": "object"
                    },
                    "maxItems": 20,
                    "type": "array"
                  },
                  "presentationStyle": {
                    "description": "Clipboard presentation style.",
                    "enum": [
                      "unspecified",
                      "inline",
                      "attachment"
                    ],
                    "type": "string"
                  }
                },
                "required": [
                  "entries"
                ],
                "type": "object"
              },
              "maxItems": 20,
              "type": "array"
            },
            "text": {
              "description": "Plain clipboard text.",
              "maxLength": 500000,
              "type": "string"
            }
          },
          "required": [
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_clipboard"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/logs",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser logs <tab-id> [--input <json>]",
        "contract": "agent-v1",
        "description": "Read bounded console and runtime logs captured for a run-owned Browser tab.",
        "id": "browser.logs",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.logs",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Read bounded console and runtime logs captured for a run-owned Browser tab"
        },
        "capabilityId": "browser.logs",
        "description": "Read bounded console and runtime logs captured for a run-owned Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "clear": {
              "description": "Clear the tab log buffer after reading.",
              "type": "boolean"
            },
            "filter": {
              "description": "Case-insensitive log substring filter.",
              "maxLength": 2000,
              "type": "string"
            },
            "levels": {
              "items": {
                "description": "Log level.",
                "enum": [
                  "debug",
                  "info",
                  "log",
                  "warn",
                  "error"
                ],
                "type": "string"
              },
              "maxItems": 5,
              "type": "array"
            },
            "limit": {
              "description": "Maximum log entries.",
              "maximum": 500,
              "minimum": 1,
              "type": "number"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_logs"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/download",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser download <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Download explicit locator media without dispatching page input into a bounded run-owned artifact.",
        "id": "browser.download",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.download",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "openWorldHint": true,
          "readOnlyHint": false,
          "title": "Download explicit locator media without dispatching page input into a bounded run-owned artifact"
        },
        "capabilityId": "browser.download",
        "description": "Download explicit locator media without dispatching page input into a bounded run-owned artifact. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "locator": {
              "additionalProperties": false,
              "properties": {
                "and": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "exact": {
                  "description": "Require an exact text or attribute match.",
                  "type": "boolean"
                },
                "filter": {
                  "additionalProperties": false,
                  "properties": {
                    "has": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNot": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNotText": {
                      "description": "Excluded descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "hasText": {
                      "description": "Required descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "visible": {
                      "description": "Filter by current visibility.",
                      "type": "boolean"
                    }
                  },
                  "type": "object"
                },
                "frame": {
                  "items": {
                    "description": "CSS iframe selector.",
                    "maxLength": 1000,
                    "minLength": 1,
                    "type": "string"
                  },
                  "maxItems": 8,
                  "type": "array"
                },
                "index": {
                  "description": "Zero-based locator match index.",
                  "maximum": 499,
                  "minimum": 0,
                  "type": "number"
                },
                "name": {
                  "description": "Accessible name used with the role strategy.",
                  "maxLength": 2000,
                  "type": "string"
                },
                "or": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "position": {
                  "description": "Locator endpoint after an explicit count.",
                  "enum": [
                    "first",
                    "last"
                  ],
                  "type": "string"
                },
                "scope": {
                  "additionalProperties": false,
                  "properties": {
                    "and": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "filter": {
                      "additionalProperties": false,
                      "properties": {
                        "has": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNot": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNotText": {
                          "description": "Excluded descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "hasText": {
                          "description": "Required descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "visible": {
                          "description": "Filter by current visibility.",
                          "type": "boolean"
                        }
                      },
                      "type": "object"
                    },
                    "index": {
                      "description": "Zero-based locator match index.",
                      "maximum": 499,
                      "minimum": 0,
                      "type": "number"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "or": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "position": {
                      "description": "Locator endpoint after an explicit count.",
                      "enum": [
                        "first",
                        "last"
                      ],
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "strategy": {
                  "description": "Locator strategy.",
                  "enum": [
                    "css",
                    "testId",
                    "href",
                    "role",
                    "label",
                    "placeholder",
                    "text"
                  ],
                  "type": "string"
                },
                "value": {
                  "description": "Selector, role, label, placeholder, href, test id, or text value.",
                  "maxLength": 2000,
                  "minLength": 1,
                  "type": "string"
                }
              },
              "required": [
                "strategy",
                "value"
              ],
              "type": "object"
            },
            "mode": {
              "description": "Read-only media download mode.",
              "enum": [
                "media"
              ],
              "type": "string"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "mode",
            "locator"
          ],
          "type": "object"
        },
        "name": "rudder_browser_download"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/assets",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser assets <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "List page assets or bundle an explicit bounded selection into a run-owned temporary artifact.",
        "id": "browser.assets",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.assets",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "List page assets or bundle an explicit bounded selection into a run-owned temporary artifact"
        },
        "capabilityId": "browser.assets",
        "description": "List page assets or bundle an explicit bounded selection into a run-owned temporary artifact. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "action": {
              "description": "Asset action.",
              "enum": [
                "list",
                "bundle"
              ],
              "type": "string"
            },
            "assetIds": {
              "items": {
                "description": "Asset id.",
                "maxLength": 160,
                "type": "string"
              },
              "maxItems": 100,
              "minItems": 1,
              "type": "array"
            },
            "inventoryId": {
              "description": "Prior asset inventory id.",
              "maxLength": 160,
              "type": "string"
            },
            "kinds": {
              "items": {
                "description": "Asset kind.",
                "enum": [
                  "font",
                  "image",
                  "stylesheet",
                  "video"
                ],
                "type": "string"
              },
              "maxItems": 4,
              "minItems": 1,
              "type": "array"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "action"
          ],
          "type": "object"
        },
        "name": "rudder_browser_assets"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/content",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser content <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Export current page content or an eligible Google Workspace document into a bounded run-owned artifact.",
        "id": "browser.content",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.content",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "openWorldHint": true,
          "readOnlyHint": false,
          "title": "Export current page content or an eligible Google Workspace document into a bounded run-owned artifact"
        },
        "capabilityId": "browser.content",
        "description": "Export current page content or an eligible Google Workspace document into a bounded run-owned artifact. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "format": {
              "description": "Content export format.",
              "enum": [
                "text",
                "pdf",
                "md",
                "docx",
                "xlsx",
                "csv",
                "pptx"
              ],
              "type": "string"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "format"
          ],
          "type": "object"
        },
        "name": "rudder_browser_content"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/wait",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser wait <tab-id> --input <json>",
        "contract": "agent-v1",
        "description": "Wait for bounded URL, text, disappearance, or time conditions in a run-owned Browser tab.",
        "id": "browser.wait",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.wait",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Wait for bounded URL, text, disappearance, or time conditions in a run-owned Browser tab"
        },
        "capabilityId": "browser.wait",
        "description": "Wait for bounded URL, text, disappearance, or time conditions in a run-owned Browser tab. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            },
            "text": {
              "description": "Text that must appear.",
              "maxLength": 10000,
              "type": "string"
            },
            "textGone": {
              "description": "Text that must disappear.",
              "maxLength": 10000,
              "type": "string"
            },
            "timeMs": {
              "description": "Fixed bounded delay in milliseconds.",
              "maximum": 30000,
              "minimum": 0,
              "type": "number"
            },
            "timeoutMs": {
              "description": "Wait timeout in milliseconds.",
              "maximum": 30000,
              "minimum": 0,
              "type": "number"
            },
            "url": {
              "description": "URL substring.",
              "maxLength": 8192,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_wait"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/read",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "browser",
        "command": "rudder browser read <tab-id>",
        "contract": "agent-v1",
        "description": "Read a structured snapshot from a run-owned Rudder Browser tab.",
        "id": "browser.read",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.read",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a structured snapshot from a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.read",
        "description": "Read a structured snapshot from a run-owned Rudder Browser tab. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_read"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/click",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser click <tab-id> <ref>",
        "contract": "agent-v1",
        "description": "Click an element reference returned by Rudder Browser read.",
        "id": "browser.click",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.click",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Click an element reference returned by Rudder Browser read"
        },
        "capabilityId": "browser.click",
        "description": "Click an element reference returned by Rudder Browser read. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "ref": {
              "description": "Element reference returned by rudder_browser_read.",
              "maxLength": 160,
              "type": "string"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "ref"
          ],
          "type": "object"
        },
        "name": "rudder_browser_click"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/type",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser type <tab-id> <ref> --text <text>",
        "contract": "agent-v1",
        "description": "Type into an element reference in a run-owned Rudder Browser tab.",
        "id": "browser.type",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.type",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Type into an element reference in a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.type",
        "description": "Type into an element reference in a run-owned Rudder Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "ref": {
              "description": "Element reference returned by rudder_browser_read.",
              "maxLength": 160,
              "type": "string"
            },
            "submit": {
              "description": "Submit the owning form after typing.",
              "type": "boolean"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            },
            "text": {
              "description": "Text to enter.",
              "maxLength": 100000,
              "type": "string"
            }
          },
          "required": [
            "tabId",
            "ref",
            "text"
          ],
          "type": "object"
        },
        "name": "rudder_browser_type"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/screenshot",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "browser",
        "command": "rudder browser screenshot <tab-id> [--input <json>]",
        "contract": "agent-v1",
        "description": "Capture a screenshot of a run-owned Rudder Browser tab.",
        "id": "browser.screenshot",
        "mutating": false,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.screenshot",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Capture a screenshot of a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.screenshot",
        "description": "Capture a screenshot of a run-owned Rudder Browser tab. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "clip": {
              "additionalProperties": false,
              "properties": {
                "height": {
                  "description": "Clip height.",
                  "minimum": 1,
                  "type": "number"
                },
                "width": {
                  "description": "Clip width.",
                  "minimum": 1,
                  "type": "number"
                },
                "x": {
                  "description": "Clip X coordinate.",
                  "type": "number"
                },
                "y": {
                  "description": "Clip Y coordinate.",
                  "type": "number"
                }
              },
              "required": [
                "x",
                "y",
                "width",
                "height"
              ],
              "type": "object"
            },
            "format": {
              "description": "Image format.",
              "enum": [
                "png",
                "jpeg"
              ],
              "type": "string"
            },
            "fullPage": {
              "description": "Capture the full scrollable page.",
              "type": "boolean"
            },
            "locator": {
              "additionalProperties": false,
              "properties": {
                "and": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "exact": {
                  "description": "Require an exact text or attribute match.",
                  "type": "boolean"
                },
                "filter": {
                  "additionalProperties": false,
                  "properties": {
                    "has": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNot": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "hasNotText": {
                      "description": "Excluded descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "hasText": {
                      "description": "Required descendant text.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "visible": {
                      "description": "Filter by current visibility.",
                      "type": "boolean"
                    }
                  },
                  "type": "object"
                },
                "frame": {
                  "items": {
                    "description": "CSS iframe selector.",
                    "maxLength": 1000,
                    "minLength": 1,
                    "type": "string"
                  },
                  "maxItems": 8,
                  "type": "array"
                },
                "index": {
                  "description": "Zero-based locator match index.",
                  "maximum": 499,
                  "minimum": 0,
                  "type": "number"
                },
                "name": {
                  "description": "Accessible name used with the role strategy.",
                  "maxLength": 2000,
                  "type": "string"
                },
                "or": {
                  "additionalProperties": false,
                  "properties": {
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "position": {
                  "description": "Locator endpoint after an explicit count.",
                  "enum": [
                    "first",
                    "last"
                  ],
                  "type": "string"
                },
                "scope": {
                  "additionalProperties": false,
                  "properties": {
                    "and": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "exact": {
                      "description": "Require an exact text or attribute match.",
                      "type": "boolean"
                    },
                    "filter": {
                      "additionalProperties": false,
                      "properties": {
                        "has": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNot": {
                          "additionalProperties": false,
                          "properties": {
                            "exact": {
                              "description": "Require an exact text or attribute match.",
                              "type": "boolean"
                            },
                            "name": {
                              "description": "Accessible name used with the role strategy.",
                              "maxLength": 2000,
                              "type": "string"
                            },
                            "strategy": {
                              "description": "Locator strategy.",
                              "enum": [
                                "css",
                                "testId",
                                "href",
                                "role",
                                "label",
                                "placeholder",
                                "text"
                              ],
                              "type": "string"
                            },
                            "value": {
                              "description": "Selector, role, label, placeholder, href, test id, or text value.",
                              "maxLength": 2000,
                              "minLength": 1,
                              "type": "string"
                            }
                          },
                          "required": [
                            "strategy",
                            "value"
                          ],
                          "type": "object"
                        },
                        "hasNotText": {
                          "description": "Excluded descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "hasText": {
                          "description": "Required descendant text.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "visible": {
                          "description": "Filter by current visibility.",
                          "type": "boolean"
                        }
                      },
                      "type": "object"
                    },
                    "index": {
                      "description": "Zero-based locator match index.",
                      "maximum": 499,
                      "minimum": 0,
                      "type": "number"
                    },
                    "name": {
                      "description": "Accessible name used with the role strategy.",
                      "maxLength": 2000,
                      "type": "string"
                    },
                    "or": {
                      "additionalProperties": false,
                      "properties": {
                        "exact": {
                          "description": "Require an exact text or attribute match.",
                          "type": "boolean"
                        },
                        "name": {
                          "description": "Accessible name used with the role strategy.",
                          "maxLength": 2000,
                          "type": "string"
                        },
                        "strategy": {
                          "description": "Locator strategy.",
                          "enum": [
                            "css",
                            "testId",
                            "href",
                            "role",
                            "label",
                            "placeholder",
                            "text"
                          ],
                          "type": "string"
                        },
                        "value": {
                          "description": "Selector, role, label, placeholder, href, test id, or text value.",
                          "maxLength": 2000,
                          "minLength": 1,
                          "type": "string"
                        }
                      },
                      "required": [
                        "strategy",
                        "value"
                      ],
                      "type": "object"
                    },
                    "position": {
                      "description": "Locator endpoint after an explicit count.",
                      "enum": [
                        "first",
                        "last"
                      ],
                      "type": "string"
                    },
                    "strategy": {
                      "description": "Locator strategy.",
                      "enum": [
                        "css",
                        "testId",
                        "href",
                        "role",
                        "label",
                        "placeholder",
                        "text"
                      ],
                      "type": "string"
                    },
                    "value": {
                      "description": "Selector, role, label, placeholder, href, test id, or text value.",
                      "maxLength": 2000,
                      "minLength": 1,
                      "type": "string"
                    }
                  },
                  "required": [
                    "strategy",
                    "value"
                  ],
                  "type": "object"
                },
                "strategy": {
                  "description": "Locator strategy.",
                  "enum": [
                    "css",
                    "testId",
                    "href",
                    "role",
                    "label",
                    "placeholder",
                    "text"
                  ],
                  "type": "string"
                },
                "value": {
                  "description": "Selector, role, label, placeholder, href, test id, or text value.",
                  "maxLength": 2000,
                  "minLength": 1,
                  "type": "string"
                }
              },
              "required": [
                "strategy",
                "value"
              ],
              "type": "object"
            },
            "quality": {
              "description": "JPEG quality.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_screenshot"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/browser/close",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "browser",
        "command": "rudder browser close <tab-id>",
        "contract": "agent-v1",
        "description": "Close a run-owned Rudder Browser tab.",
        "id": "browser.close",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": true,
        "requiresRunId": true
      },
      "id": "browser.close",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": false,
          "title": "Close a run-owned Rudder Browser tab"
        },
        "capabilityId": "browser.close",
        "description": "Close a run-owned Rudder Browser tab. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "tabId": {
              "description": "Run-owned Rudder Browser tab id.",
              "maxLength": 160,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "tabId"
          ],
          "type": "object"
        },
        "name": "rudder_browser_close"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "automation",
        "command": "rudder automation list --org-id <id>",
        "contract": "agent-v1",
        "description": "List automations for an organization with compact local filters.",
        "id": "automation.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "automation.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List automations for an organization with compact local filters"
        },
        "capabilityId": "automation.list",
        "description": "List automations for an organization with compact local filters. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "outputMode": {
              "description": "Output mode filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Automation status filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_automation_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "automation",
        "command": "rudder automation get <automation-id>",
        "contract": "agent-v1",
        "description": "Read one automation detail including triggers and recent runs.",
        "id": "automation.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one automation detail including triggers and recent runs"
        },
        "capabilityId": "automation.get",
        "description": "Read one automation detail including triggers and recent runs. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "automation",
        "command": "rudder automation runs <automation-id>",
        "contract": "agent-v1",
        "description": "List recent runs for one automation.",
        "id": "automation.runs",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.runs",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List recent runs for one automation"
        },
        "capabilityId": "automation.runs",
        "description": "List recent runs for one automation. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Maximum run rows.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_runs"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "automation",
        "command": "rudder automation triggers list <automation-id>",
        "contract": "agent-v1",
        "description": "List triggers configured for one automation.",
        "id": "automation.triggers.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.triggers.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List triggers configured for one automation"
        },
        "capabilityId": "automation.triggers.list",
        "description": "List triggers configured for one automation. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_triggers_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation triggers create <automation-id> --kind <kind>",
        "contract": "agent-v1",
        "description": "Create a schedule, webhook, or API trigger through the governed automation API.",
        "id": "automation.triggers.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.triggers.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create a schedule, webhook, or API trigger through the governed automation API"
        },
        "capabilityId": "automation.triggers.create",
        "description": "Create a schedule, webhook, or API trigger through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "cronExpression": {
              "description": "Cron expression.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "disabled": {
              "description": "Create the trigger disabled.",
              "type": "boolean"
            },
            "enabled": {
              "description": "Create the trigger enabled.",
              "type": "boolean"
            },
            "kind": {
              "description": "Trigger kind.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "label": {
              "description": "Trigger label.",
              "maxLength": 300,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "replayWindowSec": {
              "description": "Webhook replay window in seconds.",
              "maxLength": 30,
              "minLength": 1,
              "type": "string"
            },
            "signingMode": {
              "description": "Webhook signing mode.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "timezone": {
              "description": "IANA timezone.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_triggers_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation triggers update <trigger-id>",
        "contract": "agent-v1",
        "description": "Update an automation trigger through the governed automation API.",
        "id": "automation.triggers.update",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.triggers.update",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Update an automation trigger through the governed automation API"
        },
        "capabilityId": "automation.triggers.update",
        "description": "Update an automation trigger through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "cronExpression": {
              "description": "Cron expression.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "disabled": {
              "description": "Disable the trigger.",
              "type": "boolean"
            },
            "enabled": {
              "description": "Enable the trigger.",
              "type": "boolean"
            },
            "label": {
              "description": "Trigger label.",
              "maxLength": 300,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "replayWindowSec": {
              "description": "Webhook replay window in seconds.",
              "maxLength": 30,
              "minLength": 1,
              "type": "string"
            },
            "signingMode": {
              "description": "Webhook signing mode.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "timezone": {
              "description": "IANA timezone.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "trigger": {
              "description": "Automation trigger UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "trigger"
          ],
          "type": "object"
        },
        "name": "rudder_automation_triggers_update"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation triggers delete <trigger-id>",
        "contract": "agent-v1",
        "description": "Delete an automation trigger through the governed automation API.",
        "id": "automation.triggers.delete",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.triggers.delete",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Delete an automation trigger through the governed automation API"
        },
        "capabilityId": "automation.triggers.delete",
        "description": "Delete an automation trigger through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "trigger": {
              "description": "Automation trigger UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "trigger"
          ],
          "type": "object"
        },
        "name": "rudder_automation_triggers_delete"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation triggers rotate-secret <trigger-id>",
        "contract": "agent-v1",
        "description": "Rotate an automation webhook trigger secret through the governed automation API.",
        "id": "automation.triggers.rotate-secret",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.triggers.rotate-secret",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Rotate an automation webhook trigger secret through the governed automation API"
        },
        "capabilityId": "automation.triggers.rotate-secret",
        "description": "Rotate an automation webhook trigger secret through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "trigger": {
              "description": "Automation trigger UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "trigger"
          ],
          "type": "object"
        },
        "name": "rudder_automation_triggers_rotate_secret"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation create --org-id <id> --title <title> --assignee-agent-id <id>",
        "contract": "agent-v1",
        "description": "Create an automation through the governed automation API.",
        "id": "automation.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "automation.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create an automation through the governed automation API"
        },
        "capabilityId": "automation.create",
        "description": "Create an automation through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "catchUpPolicy": {
              "description": "Catch-up policy.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "concurrencyPolicy": {
              "description": "Concurrency policy.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Compatibility alias for instructions.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "instructions": {
              "description": "Automation instructions.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "notifyOnIssueCreated": {
              "description": "Notify when an issue is created.",
              "type": "boolean"
            },
            "outputMode": {
              "description": "Automation output mode.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "parentIssueId": {
              "description": "Parent issue id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "priority": {
              "description": "Issue priority.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Automation status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Automation title.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_automation_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation update <automation-id>",
        "contract": "agent-v1",
        "description": "Update automation fields through the governed automation API.",
        "id": "automation.update",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.update",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Update automation fields through the governed automation API"
        },
        "capabilityId": "automation.update",
        "description": "Update automation fields through the governed automation API. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "assigneeAgentId": {
              "description": "Assignee agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "catchUpPolicy": {
              "description": "Catch-up policy.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "concurrencyPolicy": {
              "description": "Concurrency policy.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "description": {
              "description": "Compatibility alias for instructions.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "goalId": {
              "description": "Goal id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "instructions": {
              "description": "Automation instructions.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "notifyOnIssueCreated": {
              "description": "Notify when an issue is created.",
              "type": "boolean"
            },
            "outputMode": {
              "description": "Automation output mode.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "parentIssueId": {
              "description": "Parent issue id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "priority": {
              "description": "Issue priority.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "projectId": {
              "description": "Project id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Automation status.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Automation title.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_update"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation enable <automation-id>",
        "contract": "agent-v1",
        "description": "Enable an automation by setting status to active.",
        "id": "automation.enable",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.enable",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Enable an automation by setting status to active"
        },
        "capabilityId": "automation.enable",
        "description": "Enable an automation by setting status to active. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_enable"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation disable <automation-id>",
        "contract": "agent-v1",
        "description": "Disable an automation by setting status to paused.",
        "id": "automation.disable",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.disable",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Disable an automation by setting status to paused"
        },
        "capabilityId": "automation.disable",
        "description": "Disable an automation by setting status to paused. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_disable"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "automation",
        "command": "rudder automation run <automation-id>",
        "contract": "agent-v1",
        "description": "Trigger a manual automation run.",
        "id": "automation.run",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "automation.run",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Trigger a manual automation run"
        },
        "capabilityId": "automation.run",
        "description": "Trigger a manual automation run. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "automation": {
              "description": "Automation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "idempotencyKey": {
              "description": "Idempotency key.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "source": {
              "description": "Invocation source.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "triggerId": {
              "description": "Trigger id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "automation"
          ],
          "type": "object"
        },
        "name": "rudder_automation_run"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat list --org-id <id>",
        "contract": "agent-v1",
        "description": "List chat conversations without dumping full message history.",
        "id": "chat.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "chat.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List chat conversations without dumping full message history"
        },
        "capabilityId": "chat.list",
        "description": "List chat conversations without dumping full message history. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "limit": {
              "description": "Maximum chat rows.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "query": {
              "description": "Optional chat query.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Chat status filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_chat_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat search <query> --org-id <id>",
        "contract": "agent-v1",
        "description": "Search chats with bounded snippets and optional scope filtering.",
        "id": "chat.search",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "chat.search",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Search chats with bounded snippets and optional scope filtering"
        },
        "capabilityId": "chat.search",
        "description": "Search chats with bounded snippets and optional scope filtering. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "limit": {
              "description": "Maximum matches.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "query": {
              "description": "Non-empty chat search query.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "scope": {
              "description": "Search scope.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "snippetChars": {
              "description": "Maximum snippet characters.",
              "maximum": 10000,
              "minimum": 100,
              "type": "number"
            },
            "status": {
              "description": "Chat status filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "query"
          ],
          "type": "object"
        },
        "name": "rudder_chat_search"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat get <chat-id-or-cht-ref>",
        "contract": "agent-v1",
        "description": "Read one chat conversation record.",
        "id": "chat.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one chat conversation record"
        },
        "capabilityId": "chat.get",
        "description": "Read one chat conversation record. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "chat"
          ],
          "type": "object"
        },
        "name": "rudder_chat_get"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat messages <chat-id-or-cht-ref> [--limit <n>] [--cursor <cursor>] [--include-transcript]",
        "contract": "agent-v1",
        "description": "Read bounded chat messages with page cursors; transcript output is omitted unless requested.",
        "id": "chat.messages",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.messages",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read bounded chat messages with page cursors"
        },
        "capabilityId": "chat.messages",
        "description": "Read bounded chat messages with page cursors; transcript output is omitted unless requested. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "includeOutput": {
              "description": "Compatibility alias for includeTranscript.",
              "type": "boolean"
            },
            "includeTranscript": {
              "description": "Include bounded transcript data.",
              "type": "boolean"
            },
            "limit": {
              "description": "Maximum message rows.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "maxOutputChars": {
              "description": "Maximum output characters per row.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            }
          },
          "required": [
            "chat"
          ],
          "type": "object"
        },
        "name": "rudder_chat_messages"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat transcript <chat-id-or-cht-ref> [--limit <n>] [--cursor <cursor>] [--max-output-chars <n>]",
        "contract": "agent-v1",
        "description": "Read paginated chat messages with assistant transcript entries clipped in human output.",
        "id": "chat.transcript",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.transcript",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read paginated chat messages with assistant transcript entries clipped in human output"
        },
        "capabilityId": "chat.transcript",
        "description": "Read paginated chat messages with assistant transcript entries clipped in human output. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Maximum transcript rows.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "maxOutputChars": {
              "description": "Maximum output characters per row.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            }
          },
          "required": [
            "chat"
          ],
          "type": "object"
        },
        "name": "rudder_chat_transcript"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "chat",
        "command": "rudder chat read <chat-id-or-cht-ref> [--turn-limit <n>] [--cursor <cursor>] [--include-output]",
        "contract": "agent-v1",
        "description": "Read a bounded recent-message snapshot for one chat with page cursors.",
        "id": "chat.read",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.read",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a bounded recent-message snapshot for one chat with page cursors"
        },
        "capabilityId": "chat.read",
        "description": "Read a bounded recent-message snapshot for one chat with page cursors. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "includeOutput": {
              "description": "Compatibility alias for includeTranscript.",
              "type": "boolean"
            },
            "includeTranscript": {
              "description": "Include bounded transcript data.",
              "type": "boolean"
            },
            "limit": {
              "description": "Maximum message rows.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "maxOutputChars": {
              "description": "Maximum output characters per row.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            },
            "turnLimit": {
              "description": "Maximum transcript turns.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            }
          },
          "required": [
            "chat"
          ],
          "type": "object"
        },
        "name": "rudder_chat_read"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "chat",
        "command": "rudder chat create --org-id <id> --body <text>",
        "contract": "agent-v1",
        "description": "Create a chat conversation with its first message.",
        "id": "chat.create",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "chat.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Create a chat conversation with its first message"
        },
        "capabilityId": "chat.create",
        "description": "Create a chat conversation with its first message. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "body": {
              "description": "Initial agent-authored chat message.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "issueCreationMode": {
              "description": "Issue creation mode.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "payload": {
              "description": "JSON payload object or JSON string.",
              "type": [
                "object",
                "string"
              ]
            },
            "planMode": {
              "description": "Start the chat in plan mode.",
              "type": "boolean"
            },
            "preferredAgentId": {
              "description": "Preferred responding agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "summary": {
              "description": "Chat summary.",
              "maxLength": 10000,
              "minLength": 1,
              "type": "string"
            },
            "title": {
              "description": "Chat title.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "body"
          ],
          "type": "object"
        },
        "name": "rudder_chat_create"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "chat",
        "command": "rudder chat send <chat-id-or-cht-ref> --body <text>",
        "contract": "agent-v1",
        "description": "Send an agent-authored message directly to the operator in a chat.",
        "id": "chat.send",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.send",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Send an agent-authored message directly to the operator in a chat"
        },
        "capabilityId": "chat.send",
        "description": "Send an agent-authored message directly to the operator in a chat. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "body": {
              "description": "Agent-authored chat message.",
              "maxLength": 500000,
              "minLength": 1,
              "type": "string"
            },
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "editUserMessageId": {
              "description": "User message id to edit.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "chat",
            "body"
          ],
          "type": "object"
        },
        "name": "rudder_chat_send"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "chat",
        "command": "rudder chat archive <chat-id-or-cht-ref>",
        "contract": "agent-v1",
        "description": "Archive a chat conversation without deleting it.",
        "id": "chat.archive",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "chat.archive",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Archive a chat conversation without deleting it"
        },
        "capabilityId": "chat.archive",
        "description": "Archive a chat conversation without deleting it. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "chat": {
              "description": "Chat conversation UUID or short reference.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "chat"
          ],
          "type": "object"
        },
        "name": "rudder_chat_archive"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/orgs/{orgId}/runs",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs list --org-id <id> [--used-skill <skill>] [--loaded-skill <skill>] [--cursor <cursor>] [--full]",
        "contract": "agent-v1",
        "description": "List lightweight run summaries with stable pagination and filters; use --full only for legacy full-row compatibility.",
        "id": "runs.list",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "runs.list",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List lightweight run summaries with stable pagination and filters"
        },
        "capabilityId": "runs.list",
        "description": "List lightweight run summaries with stable pagination and filters; use --full only for legacy full-row compatibility. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "createdBefore": {
              "description": "Only runs created before this timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "issueId": {
              "description": "Linked issue id filter.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Summary page size.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "loadedSkill": {
              "description": "Loaded skill filter.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "relatedAgentId": {
              "description": "Agent id filter.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "runIdPrefix": {
              "description": "Run id prefix filter.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "runtime": {
              "description": "Runtime type filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Run status filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "updatedAfter": {
              "description": "Only runs updated after this timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "usedSkill": {
              "description": "Used skill filter.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            }
          },
          "type": "object"
        },
        "name": "rudder_runs_list"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs by-skill <skill> --org-id <id> [--evidence <used-or-loaded>] [--cursor <cursor>] [--full]",
        "contract": "agent-v1",
        "description": "Build a paginated skill evidence packet from lightweight run summaries; use --full only for legacy full-row compatibility.",
        "id": "runs.by-skill",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": true,
        "requiresRunId": false
      },
      "id": "runs.by-skill",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Build a paginated skill evidence packet from lightweight run summaries"
        },
        "capabilityId": "runs.by-skill",
        "description": "Build a paginated skill evidence packet from lightweight run summaries; use --full only for legacy full-row compatibility. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: required from runtime env. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "createdBefore": {
              "description": "Only runs created before this timestamp.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "evidence": {
              "description": "Skill evidence type.",
              "enum": [
                "used",
                "loaded"
              ],
              "maxLength": 20,
              "minLength": 1,
              "type": "string"
            },
            "issueId": {
              "description": "Linked issue id filter.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Summary page size.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            },
            "relatedAgentId": {
              "description": "Agent id filter.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "runtime": {
              "description": "Runtime type filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            },
            "skill": {
              "description": "Skill key or display name.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "status": {
              "description": "Run status filter.",
              "maxLength": 100,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "skill"
          ],
          "type": "object"
        },
        "name": "rudder_runs_by_skill"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/runs/{run}",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs get <run-id> [--full]",
        "contract": "agent-v1",
        "description": "Read one bounded run summary; use --full only from a direct trusted CLI for raw detail.",
        "id": "runs.get",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.get",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read one bounded run summary"
        },
        "capabilityId": "runs.get",
        "description": "Read one bounded run summary; use --full only from a direct trusted CLI for raw detail. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_get"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/runs/{run}/events",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs events <run-id> [--cursor <cursor>] [--after-seq <n>] [--limit <n>] [--full]",
        "contract": "agent-v1",
        "description": "List a bounded page of persisted run events with a lossless opaque cursor and clipped payload previews.",
        "id": "runs.events",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.events",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List a bounded page of persisted run events with a lossless opaque cursor and clipped payload previews"
        },
        "capabilityId": "runs.events",
        "description": "List a bounded page of persisted run events with a lossless opaque cursor and clipped payload previews. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "afterSeq": {
              "description": "Legacy sequence-only cursor.",
              "maximum": 10000000,
              "minimum": 0,
              "type": "number"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "limit": {
              "description": "Event page size.",
              "maximum": 500,
              "minimum": 1,
              "type": "number"
            },
            "maxChars": {
              "description": "Maximum preview characters per event.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            },
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_events"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/runs/{run}/log",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs log <run-id> [--offset <bytes>] [--limit-bytes <n>]",
        "contract": "agent-v1",
        "description": "Read a bounded byte range of stored run log content.",
        "id": "runs.log",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.log",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a bounded byte range of stored run log content"
        },
        "capabilityId": "runs.log",
        "description": "Read a bounded byte range of stored run log content. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "limitBytes": {
              "description": "Maximum bytes for ranged read.",
              "maximum": 1000000,
              "minimum": 1,
              "type": "number"
            },
            "maxChars": {
              "description": "Maximum displayed log characters.",
              "maximum": 100000,
              "minimum": 100,
              "type": "number"
            },
            "offset": {
              "description": "Byte offset for ranged read.",
              "maximum": 1000000000,
              "minimum": 0,
              "type": "number"
            },
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_log"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/runs/{run}/transcript",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs transcript <run-id> [--turn-limit <n>] [--cursor <cursor>] [--include-output] [--full]",
        "contract": "agent-v1",
        "description": "Read a compact server-normalized transcript; --json changes encoding only and --full is direct-CLI-only raw access.",
        "id": "runs.transcript",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.transcript",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "Read a compact server-normalized transcript"
        },
        "capabilityId": "runs.transcript",
        "description": "Read a compact server-normalized transcript; --json changes encoding only and --full is direct-CLI-only raw access. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "aroundError": {
              "description": "Transcript error step id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "chronological": {
              "description": "Return oldest-first rows.",
              "type": "boolean"
            },
            "contextTurns": {
              "description": "Turns around the selected error.",
              "maximum": 20,
              "minimum": 1,
              "type": "number"
            },
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "errorsOnly": {
              "description": "Return only error rows.",
              "type": "boolean"
            },
            "includeOutput": {
              "description": "Include clipped row output.",
              "type": "boolean"
            },
            "maxChars": {
              "description": "Maximum output characters per row.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            },
            "narrative": {
              "description": "Use narrative row formatting.",
              "type": "boolean"
            },
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "turnLimit": {
              "description": "Maximum turns.",
              "maximum": 100,
              "minimum": 1,
              "type": "number"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_transcript"
      }
    },
    {
      "api": {
        "method": "GET",
        "pathTemplate": "/api/run-intelligence/runs/{run}/errors",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": false,
        "category": "runs",
        "command": "rudder runs errors <run-id>",
        "contract": "agent-v1",
        "description": "List failed tool calls, stderr, runtime failures, and jump-to-context commands.",
        "id": "runs.errors",
        "mutating": false,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.errors",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": true,
          "title": "List failed tool calls, stderr, runtime failures, and jump-to-context commands"
        },
        "capabilityId": "runs.errors",
        "description": "List failed tool calls, stderr, runtime failures, and jump-to-context commands. Mutating: no. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: not attached.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "cursor": {
              "description": "Opaque pagination cursor.",
              "maxLength": 2000,
              "minLength": 1,
              "type": "string"
            },
            "maxChars": {
              "description": "Maximum output characters per error.",
              "maximum": 20000,
              "minimum": 100,
              "type": "number"
            },
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_errors"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "runs",
        "command": "rudder runs cancel <run-id>",
        "contract": "agent-v1",
        "description": "Cancel a heartbeat run through the governed server route.",
        "id": "runs.cancel",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.cancel",
      "mcp": {
        "annotations": {
          "destructiveHint": true,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Cancel a heartbeat run through the governed server route"
        },
        "capabilityId": "runs.cancel",
        "description": "Cancel a heartbeat run through the governed server route. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_cancel"
      }
    },
    {
      "api": {
        "transport": "cli-fallback"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "runs",
        "command": "rudder runs retry <run-id>",
        "contract": "agent-v1",
        "description": "Retry a failed, timed out, or cancelled run through the governed server route.",
        "id": "runs.retry",
        "mutating": true,
        "requiresAgentId": false,
        "requiresOrgId": false,
        "requiresRunId": false
      },
      "id": "runs.retry",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": false,
          "readOnlyHint": false,
          "title": "Retry a failed, timed out, or cancelled run through the governed server route"
        },
        "capabilityId": "runs.retry",
        "description": "Retry a failed, timed out, or cancelled run through the governed server route. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: runtime env when available. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "run": {
              "description": "Run UUID, typed short reference (run_<prefix>), or legacy bare short prefix.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "run"
          ],
          "type": "object"
        },
        "name": "rudder_runs_retry"
      }
    },
    {
      "api": {
        "method": "POST",
        "pathTemplate": "/api/agent-runs/delegation",
        "transport": "direct"
      },
      "cli": {
        "attachesRunIdWhenAvailable": true,
        "category": "runs",
        "command": "rudder runs create --task <text> --idempotency-key <key> [--target-agent-id <id>]",
        "contract": "agent-v1",
        "description": "Create an independently governed Delegation Run for the current or another same-organization Agent.",
        "id": "runs.create",
        "mutating": true,
        "requiresAgentId": true,
        "requiresOrgId": false,
        "requiresRunId": true
      },
      "id": "runs.create",
      "mcp": {
        "annotations": {
          "destructiveHint": false,
          "idempotentHint": true,
          "readOnlyHint": false,
          "title": "Create an independently governed Delegation Run"
        },
        "capabilityId": "runs.create",
        "description": "Create an independently governed Delegation Run for the current or another same-organization Agent. Mutating: yes. Runtime identity and authorization are injected by the Rudder-managed MCP server and are not accepted as tool input. Org context: not required by this tool. Agent context: required from runtime env. Run attribution: attached from runtime env when available.",
        "inputSchema": {
          "additionalProperties": false,
          "properties": {
            "idempotencyKey": {
              "description": "Required stable key for safe replay.",
              "maxLength": 500,
              "minLength": 1,
              "type": "string"
            },
            "targetAgentId": {
              "description": "Optional same-organization target Agent id.",
              "maxLength": 200,
              "minLength": 1,
              "type": "string"
            },
            "task": {
              "description": "Delegation task to run independently.",
              "maxLength": 20000,
              "minLength": 1,
              "type": "string"
            }
          },
          "required": [
            "task",
            "idempotencyKey"
          ],
          "type": "object"
        },
        "name": "rudder_runs_create"
      }
    }
  ],
  "contractVersion": "rudder.agent-contract/v1",
  "differentialFixtures": [
    {
      "expected": {
        "data": {
          "id": "run_123",
          "state": "succeeded"
        },
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "success",
      "left": {
        "data": {
          "id": "run_123",
          "state": "succeeded"
        },
        "meta": {
          "requestId": "node-1",
          "transport": "node"
        },
        "status": "ok"
      },
      "profile": "success",
      "right": {
        "data": {
          "id": "run_123",
          "state": "succeeded"
        },
        "meta": {
          "requestId": "rust-1",
          "transport": "rust"
        },
        "status": "ok"
      }
    },
    {
      "expected": {
        "error": {
          "code": "forbidden",
          "message": "Forbidden",
          "stack": "<non-semantic>"
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "authorization",
      "left": {
        "error": {
          "code": "forbidden",
          "message": "Forbidden",
          "stack": "node stack"
        },
        "meta": {
          "requestId": "node-2"
        },
        "status": "error"
      },
      "profile": "authorization",
      "right": {
        "error": {
          "code": "forbidden",
          "message": "Forbidden",
          "stack": "rust stack"
        },
        "meta": {
          "requestId": "rust-2"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "error": {
          "code": "invalid_arguments",
          "details": {
            "field": "issue"
          }
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "validation",
      "left": {
        "error": {
          "code": "invalid_arguments",
          "details": {
            "field": "issue"
          }
        },
        "meta": {
          "requestId": "node-3"
        },
        "status": "error"
      },
      "profile": "validation",
      "right": {
        "error": {
          "code": "invalid_arguments",
          "details": {
            "field": "issue"
          }
        },
        "meta": {
          "requestId": "rust-3"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "error": {
          "code": "rudder_mcp_response_too_large",
          "details": {
            "maxBytes": 1000000
          }
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "bounded-output",
      "left": {
        "error": {
          "code": "rudder_mcp_response_too_large",
          "details": {
            "maxBytes": 1000000
          }
        },
        "meta": {
          "requestId": "node-4"
        },
        "status": "error"
      },
      "profile": "bounded_output",
      "right": {
        "error": {
          "code": "rudder_mcp_response_too_large",
          "details": {
            "maxBytes": 1000000
          }
        },
        "meta": {
          "requestId": "rust-4"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "error": {
          "code": "aborted"
        },
        "meta": {
          "elapsedMs": "<non-semantic>",
          "requestId": "<non-semantic>"
        },
        "status": "cancelled"
      },
      "id": "cancellation",
      "left": {
        "error": {
          "code": "aborted"
        },
        "meta": {
          "elapsedMs": 12,
          "requestId": "node-5"
        },
        "status": "cancelled"
      },
      "profile": "cancellation",
      "right": {
        "error": {
          "code": "aborted"
        },
        "meta": {
          "elapsedMs": 8,
          "requestId": "rust-5"
        },
        "status": "cancelled"
      }
    },
    {
      "expected": {
        "error": {
          "code": "rudder_mcp_missing_runtime_context",
          "details": {
            "missing": [
              "RUDDER_API_KEY"
            ]
          }
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "runtime-context-error",
      "left": {
        "error": {
          "code": "rudder_mcp_missing_runtime_context",
          "details": {
            "missing": [
              "RUDDER_API_KEY"
            ]
          }
        },
        "meta": {
          "requestId": "node-6"
        },
        "status": "error"
      },
      "profile": "runtime_context_error",
      "right": {
        "error": {
          "code": "rudder_mcp_missing_runtime_context",
          "details": {
            "missing": [
              "RUDDER_API_KEY"
            ]
          }
        },
        "meta": {
          "requestId": "rust-6"
        },
        "status": "error"
      }
    }
  ],
  "g0DifferentialFixtures": [
    {
      "expected": {
        "error": {
          "message": "Goal short reference is ambiguous. Use a longer typed ref.",
          "status": 409
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "goal-typed-reference-ambiguity",
      "left": {
        "error": {
          "message": "Goal short reference is ambiguous. Use a longer typed ref.",
          "status": 409
        },
        "meta": {
          "requestId": "node-goal"
        },
        "status": "error"
      },
      "nodeEvidence": [
        "server/src/routes/goals.ts:78",
        "server/src/routes/goals.ts:92",
        "server/src/services/goals.ts:2059"
      ],
      "profile": "validation",
      "right": {
        "error": {
          "message": "Goal short reference is ambiguous. Use a longer typed ref.",
          "status": 409
        },
        "meta": {
          "requestId": "rust-goal"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "error": {
          "message": "Agent key cannot access another organization",
          "status": 403
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "organization-fencing",
      "left": {
        "error": {
          "message": "Agent key cannot access another organization",
          "status": 403
        },
        "meta": {
          "requestId": "node-org"
        },
        "status": "error"
      },
      "nodeEvidence": [
        "server/src/routes/authz.ts",
        "server/src/__tests__/rudder-plugins-agent-read-routes.test.ts:77"
      ],
      "profile": "authorization",
      "right": {
        "error": {
          "message": "Agent key cannot access another organization",
          "status": 403
        },
        "meta": {
          "requestId": "rust-org"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "data": {
          "hasMore": true,
          "items": [
            {
              "name": "Ada",
              "ref": "agt_d573266f",
              "role": "builder",
              "type": "agent"
            }
          ],
          "nextCursor": "eyJuYW1lIjoiQWRhIiwidHlwZSI6ImFnZW50IiwicHJpbmNpcGFsSWQiOiJkNTczMjY2Zi1hZjk1LTQ0ZTYtOTMwMy1lOTAzYTU0NjYyYjgifQ",
          "total": 2
        },
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "member-filter-pagination",
      "left": {
        "data": {
          "hasMore": true,
          "items": [
            {
              "name": "Ada",
              "ref": "agt_d573266f",
              "role": "builder",
              "type": "agent"
            }
          ],
          "nextCursor": "eyJuYW1lIjoiQWRhIiwidHlwZSI6ImFnZW50IiwicHJpbmNpcGFsSWQiOiJkNTczMjY2Zi1hZjk1LTQ0ZTYtOTMwMy1lOTAzYTU0NjYyYjgifQ",
          "total": 2
        },
        "meta": {
          "requestId": "node-members",
          "transport": "node"
        },
        "status": "ok"
      },
      "nodeEvidence": [
        "server/src/services/organization-members.ts:33",
        "server/src/services/organization-members.ts:210",
        "cli/src/__tests__/organization-members.test.ts:10"
      ],
      "profile": "success",
      "right": {
        "data": {
          "hasMore": true,
          "items": [
            {
              "name": "Ada",
              "ref": "agt_d573266f",
              "role": "builder",
              "type": "agent"
            }
          ],
          "nextCursor": "eyJuYW1lIjoiQWRhIiwidHlwZSI6ImFnZW50IiwicHJpbmNpcGFsSWQiOiJkNTczMjY2Zi1hZjk1LTQ0ZTYtOTMwMy1lOTAzYTU0NjYyYjgifQ",
          "total": 2
        },
        "meta": {
          "requestId": "rust-members",
          "transport": "rust"
        },
        "status": "ok"
      }
    },
    {
      "expected": {
        "data": [
          {
            "attachedAgentCount": 2,
            "compatibility": "compatible",
            "createdAt": "2026-08-28T00:00:00.000Z",
            "description": "Review product design evidence.",
            "editable": true,
            "editableReason": null,
            "fileInventory": [
              {
                "kind": "skill",
                "path": "SKILL.md"
              }
            ],
            "id": "0b17168c-9bb5-4ef1-91ca-5b67b8e22a31",
            "key": "organization/11111111-1111-4111-8111-111111111111/design-review",
            "name": "Design Review",
            "orgId": "11111111-1111-4111-8111-111111111111",
            "slug": "design-review",
            "sourceBadge": "local",
            "sourceLabel": "Organization library",
            "sourceLocator": "/workspace/skills/design-review",
            "sourcePath": "/workspace/skills/design-review/SKILL.md",
            "sourceRef": null,
            "sourceType": "local_path",
            "trustLevel": "markdown_only",
            "updatedAt": "2026-08-28T01:00:00.000Z",
            "workspaceEditPath": "/workspace/skills/design-review"
          }
        ],
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "skill-search-match",
      "left": {
        "data": [
          {
            "attachedAgentCount": 2,
            "compatibility": "compatible",
            "createdAt": "2026-08-28T00:00:00.000Z",
            "description": "Review product design evidence.",
            "editable": true,
            "editableReason": null,
            "fileInventory": [
              {
                "kind": "skill",
                "path": "SKILL.md"
              }
            ],
            "id": "0b17168c-9bb5-4ef1-91ca-5b67b8e22a31",
            "key": "organization/11111111-1111-4111-8111-111111111111/design-review",
            "name": "Design Review",
            "orgId": "11111111-1111-4111-8111-111111111111",
            "slug": "design-review",
            "sourceBadge": "local",
            "sourceLabel": "Organization library",
            "sourceLocator": "/workspace/skills/design-review",
            "sourcePath": "/workspace/skills/design-review/SKILL.md",
            "sourceRef": null,
            "sourceType": "local_path",
            "trustLevel": "markdown_only",
            "updatedAt": "2026-08-28T01:00:00.000Z",
            "workspaceEditPath": "/workspace/skills/design-review"
          }
        ],
        "meta": {
          "requestId": "node-skill",
          "transport": "node"
        },
        "status": "ok"
      },
      "nodeEvidence": [
        "packages/shared/src/types/organization-skill.ts:42",
        "cli/src/commands/client/skill.ts:28",
        "cli/src/__tests__/skill-search.test.ts:19"
      ],
      "profile": "success",
      "right": {
        "data": [
          {
            "attachedAgentCount": 2,
            "compatibility": "compatible",
            "createdAt": "2026-08-28T00:00:00.000Z",
            "description": "Review product design evidence.",
            "editable": true,
            "editableReason": null,
            "fileInventory": [
              {
                "kind": "skill",
                "path": "SKILL.md"
              }
            ],
            "id": "0b17168c-9bb5-4ef1-91ca-5b67b8e22a31",
            "key": "organization/11111111-1111-4111-8111-111111111111/design-review",
            "name": "Design Review",
            "orgId": "11111111-1111-4111-8111-111111111111",
            "slug": "design-review",
            "sourceBadge": "local",
            "sourceLabel": "Organization library",
            "sourceLocator": "/workspace/skills/design-review",
            "sourcePath": "/workspace/skills/design-review/SKILL.md",
            "sourceRef": null,
            "sourceType": "local_path",
            "trustLevel": "markdown_only",
            "updatedAt": "2026-08-28T01:00:00.000Z",
            "workspaceEditPath": "/workspace/skills/design-review"
          }
        ],
        "meta": {
          "requestId": "rust-skill",
          "transport": "rust"
        },
        "status": "ok"
      }
    },
    {
      "expected": {
        "data": [],
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "skill-search-empty",
      "left": {
        "data": [],
        "meta": {
          "requestId": "node-empty",
          "transport": "node"
        },
        "status": "ok"
      },
      "nodeEvidence": [
        "packages/shared/src/types/organization-skill.ts:42",
        "cli/src/commands/client/skill.ts:28",
        "cli/src/__tests__/skill-search.test.ts:19"
      ],
      "profile": "success",
      "right": {
        "data": [],
        "meta": {
          "requestId": "rust-empty",
          "transport": "rust"
        },
        "status": "ok"
      }
    },
    {
      "expected": {
        "data": {
          "components": [
            {
              "displayName": "Canva Design",
              "id": "74178b52-f290-4cd4-9c3b-40b5f1b391ac",
              "key": "canva-design",
              "metadata": {},
              "status": "ready",
              "targetId": "4bccbfc2-cf76-4634-8d1d-b926dd55c6fe",
              "type": "skill"
            }
          ],
          "description": "Create and edit visual designs.",
          "digest": "sha256:48e3482b14b50b50",
          "displayName": "Canva",
          "enabled": true,
          "healthState": "healthy",
          "id": "86f6573e-2707-438b-9334-696c91fd0856",
          "installedAt": "2026-08-28T00:00:00.000Z",
          "lifecycleState": "installed",
          "manifest": {
            "name": "canva",
            "version": "1.0.0"
          },
          "name": "canva",
          "orgId": "11111111-1111-4111-8111-111111111111",
          "packageId": "37cd87c6-310d-43ba-b961-b836f43fc626",
          "pendingUpdate": null,
          "previousPackageId": null,
          "publisher": "Canva",
          "setupState": "ready",
          "sourceLabel": "OpenAI plugins",
          "updateState": "none",
          "updatedAt": "2026-08-28T01:00:00.000Z",
          "version": "1.0.0"
        },
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "plugin-projection-reference",
      "left": {
        "data": {
          "components": [
            {
              "displayName": "Canva Design",
              "id": "74178b52-f290-4cd4-9c3b-40b5f1b391ac",
              "key": "canva-design",
              "metadata": {},
              "status": "ready",
              "targetId": "4bccbfc2-cf76-4634-8d1d-b926dd55c6fe",
              "type": "skill"
            }
          ],
          "description": "Create and edit visual designs.",
          "digest": "sha256:48e3482b14b50b50",
          "displayName": "Canva",
          "enabled": true,
          "healthState": "healthy",
          "id": "86f6573e-2707-438b-9334-696c91fd0856",
          "installedAt": "2026-08-28T00:00:00.000Z",
          "lifecycleState": "installed",
          "manifest": {
            "name": "canva",
            "version": "1.0.0"
          },
          "name": "canva",
          "orgId": "11111111-1111-4111-8111-111111111111",
          "packageId": "37cd87c6-310d-43ba-b961-b836f43fc626",
          "pendingUpdate": null,
          "previousPackageId": null,
          "publisher": "Canva",
          "setupState": "ready",
          "sourceLabel": "OpenAI plugins",
          "updateState": "none",
          "updatedAt": "2026-08-28T01:00:00.000Z",
          "version": "1.0.0"
        },
        "meta": {
          "requestId": "node-plugin",
          "transport": "node"
        },
        "status": "ok"
      },
      "nodeEvidence": [
        "packages/shared/src/types/plugin-v1.ts:146",
        "server/src/services/rudder-plugins.ts:1368",
        "server/src/__tests__/rudder-plugins-agent-read-routes.test.ts:69"
      ],
      "profile": "success",
      "right": {
        "data": {
          "components": [
            {
              "displayName": "Canva Design",
              "id": "74178b52-f290-4cd4-9c3b-40b5f1b391ac",
              "key": "canva-design",
              "metadata": {},
              "status": "ready",
              "targetId": "4bccbfc2-cf76-4634-8d1d-b926dd55c6fe",
              "type": "skill"
            }
          ],
          "description": "Create and edit visual designs.",
          "digest": "sha256:48e3482b14b50b50",
          "displayName": "Canva",
          "enabled": true,
          "healthState": "healthy",
          "id": "86f6573e-2707-438b-9334-696c91fd0856",
          "installedAt": "2026-08-28T00:00:00.000Z",
          "lifecycleState": "installed",
          "manifest": {
            "name": "canva",
            "version": "1.0.0"
          },
          "name": "canva",
          "orgId": "11111111-1111-4111-8111-111111111111",
          "packageId": "37cd87c6-310d-43ba-b961-b836f43fc626",
          "pendingUpdate": null,
          "previousPackageId": null,
          "publisher": "Canva",
          "setupState": "ready",
          "sourceLabel": "OpenAI plugins",
          "updateState": "none",
          "updatedAt": "2026-08-28T01:00:00.000Z",
          "version": "1.0.0"
        },
        "meta": {
          "requestId": "rust-plugin",
          "transport": "rust"
        },
        "status": "ok"
      }
    },
    {
      "expected": {
        "error": {
          "message": "Installed Plugin not found",
          "status": 404
        },
        "meta": {
          "requestId": "<non-semantic>"
        },
        "status": "error"
      },
      "id": "plugin-not-found",
      "left": {
        "error": {
          "message": "Installed Plugin not found",
          "status": 404
        },
        "meta": {
          "requestId": "node-plugin-missing"
        },
        "status": "error"
      },
      "nodeEvidence": [
        "server/src/routes/rudder-plugins.ts:117",
        "server/src/services/rudder-plugins.ts:1418"
      ],
      "profile": "authorization",
      "right": {
        "error": {
          "message": "Installed Plugin not found",
          "status": 404
        },
        "meta": {
          "requestId": "rust-plugin-missing"
        },
        "status": "error"
      }
    },
    {
      "expected": {
        "data": {
          "assigneeAgentId": "agt_33333333",
          "createdByAgentId": "agt_33333333",
          "id": "R6Z-124",
          "identifier": "R6Z-124",
          "originRunId": "run_44444444",
          "priority": "medium",
          "requestDepth": 1,
          "status": "todo",
          "title": "Agent-created lifecycle issue"
        },
        "meta": {
          "requestId": "<non-semantic>",
          "transport": "<non-semantic>"
        },
        "status": "ok"
      },
      "id": "issue-create-defaults-attribution",
      "left": {
        "data": {
          "assigneeAgentId": "agt_33333333",
          "createdByAgentId": "agt_33333333",
          "id": "R6Z-124",
          "identifier": "R6Z-124",
          "originRunId": "run_44444444",
          "priority": "medium",
          "requestDepth": 1,
          "status": "todo",
          "title": "Agent-created lifecycle issue"
        },
        "meta": {
          "requestId": "node-issue",
          "transport": "node"
        },
        "status": "ok"
      },
      "nodeEvidence": [
        "server/src/routes/issues.mutations.ts:218",
        "server/src/routes/issues.mutations.ts:264",
        "server/src/routes/issues.mutations.ts:278",
        "server/src/__tests__/issue-lifecycle-routes.test.ts:759",
        "cli/src/__tests__/agent-v1-mcp-server.test.ts:326"
      ],
      "profile": "success",
      "right": {
        "data": {
          "assigneeAgentId": "agt_33333333",
          "createdByAgentId": "agt_33333333",
          "id": "R6Z-124",
          "identifier": "R6Z-124",
          "originRunId": "run_44444444",
          "priority": "medium",
          "requestDepth": 1,
          "status": "todo",
          "title": "Agent-created lifecycle issue"
        },
        "meta": {
          "requestId": "rust-issue",
          "transport": "rust"
        },
        "status": "ok"
      }
    }
  ],
  "normalizationProfiles": {
    "authorization": [
      "/meta/requestId",
      "/error/stack"
    ],
    "bounded_output": [
      "/meta/requestId"
    ],
    "cancellation": [
      "/meta/requestId",
      "/meta/elapsedMs"
    ],
    "runtime_context_error": [
      "/meta/requestId"
    ],
    "success": [
      "/meta/requestId",
      "/meta/transport"
    ],
    "validation": [
      "/meta/requestId"
    ]
  },
  "schema": "rudder.agent-contract-source/v1"
} as const;
export const RUDDER_AGENT_CONTRACT_HASH = "c97d1031e16cde221a04bbc7e14bef57835e76c4a6d637f2c4cd77ef346bce14";
